(function () {
  "use strict";

  var root = document.querySelector("[data-drsknn-v5]");
  if (!root || root.dataset.v5Ready === "1") return;
  root.dataset.v5Ready = "1";
  if (/\/pages\/dr-sknn-landing-v5\/?$/.test(window.location.pathname || "")) {
    document.body.classList.add("drsknn-v5-active-page");
  }

  var GOOGLE_PLACES_API_KEY = "AIzaSyDCX6AgsjLisxjIle7tYdxVhTQI0V5aXQI";
  var GOOGLE_PLACE_ID = "ChIJ-7JdE7NNekgRpxOzXg2xuUo";
  var GOOGLE_REVIEWS_URL = "https://www.google.com/maps/search/?api=1&query=Dr%20Sknn%20Wilmslow&query_place_id=" + GOOGLE_PLACE_ID;
  var GOOGLE_REVIEWS_API_URL = "https://www.drsknn.uk/api/google_reviews_all?place_id=" + encodeURIComponent(GOOGLE_PLACE_ID);
  var GOOGLE_REVIEWS_FALLBACK_API_URL = "https://www.drsknn.uk/api/google_reviews?place_id=" + encodeURIComponent(GOOGLE_PLACE_ID);
  var PABAU_REVIEW_SLUG = "drsknn";
  var PABAU_REVIEWS_URL = "https://partner.pabau.com/reviews/" + PABAU_REVIEW_SLUG;
  var PABAU_REVIEWS_API_URL = "https://www.drsknn.uk/api/pabau_reviews";
  var AVAILABILITY_API_URL = "https://www.drsknn.uk/api/hero/slots?locations=9613,24218";
  var STATE_STORAGE_KEY = "drsknn_v5_patient_state";

  var AREA_LABELS = {
    skin: "Skin route",
    face: "Face route",
    body: "Body route",
    hair: "Hair route",
    unsure: "Guided route"
  };

  var CONCERNS = [
    {
      id: "healthier",
      area: "skin",
      label: "Healthier, fresher looking skin",
      copy: "Glow, hydration, dullness, dryness and barrier support.",
      categories: ["skin-rejuvenation", "hydrafacial", "origin-laser", "personalised-skincare", "profhilo-skin-booster", "polynucleotides"],
      keywords: ["skin", "glow", "fresh", "hydration", "dehydrated", "dry", "dull", "barrier", "natural", "confidence", "hydrafacial", "laser"],
      confidence: ["Skin quality", "Hydration", "Dullness", "Barrier", "Maintenance"],
      covers: ["Dehydrated Skin", "Dullness", "Rejuvenation", "Skin Glow"],
      routes: ["Doctor-led skin assessment", "Skin health pathway", "Personalised homecare route"]
    },
    {
      id: "acne",
      area: "skin",
      label: "Acne, breakouts or acne marks",
      copy: "Active acne, recurring breakouts, acne marks and acne scarring.",
      categories: ["acne-treatment", "acne-scarring", "scar-treatment", "open-pore", "skin-rejuvenation", "origin-laser", "personalised-skincare"],
      keywords: ["acne", "acne marks", "acne scarring", "breakout", "pimples", "spots", "confidence"],
      confidence: ["Active acne", "Acne marks", "Acne scarring", "Inflammation", "Barrier"],
      covers: ["Acne"],
      routes: ["Acne and scar assessment", "Acne-control route", "Texture and scar pathway"]
    },
    {
      id: "pigment",
      area: "skin",
      label: "Pigmentation, redness or sun damage",
      copy: "Brown marks, melasma, age spots, rosacea, thread veins and uneven tone.",
      categories: ["pigmentation", "redness", "rosacea", "vascular-lesions", "origin-laser", "skin-rejuvenation"],
      keywords: ["pigment", "pigmentation", "melasma", "sun damage", "age spots", "redness", "rosacea", "vascular", "thread veins", "tone", "brown", "marks"],
      confidence: ["Pigment depth", "Background redness", "Thread veins", "Sensitivity", "Sun history"],
      covers: ["Pigmentation", "Redness", "Rosacea", "Sun Damage"],
      routes: ["Pigment and redness assessment", "Laser route where suitable", "Calming skin pathway"]
    },
    {
      id: "skin-congestion",
      area: "skin",
      label: "Pores, milia or congested skin",
      copy: "Open pores, whiteheads, oiliness, small bumps, roughness and uneven texture.",
      categories: ["open-pore", "hydrafacial", "personalised-skincare", "skin-rejuvenation", "origin-laser"],
      keywords: ["pores", "open pores", "large pores", "milia", "whiteheads", "congestion", "oiliness", "small bumps", "texture", "resurfacing"],
      confidence: ["Pore pattern", "Milia or whiteheads", "Congestion", "Texture", "Skin barrier"],
      covers: ["Milia", "Open Pores", "Skin Resurfacing", "Whiteheads"],
      routes: ["Congestion and texture assessment", "Pore and milia pathway", "Resurfacing route where suitable"]
    },
    {
      id: "skin-scarring",
      area: "skin",
      label: "Scars, keloids or uneven skin",
      copy: "Non-acne scars, raised keloid scars, scar texture and colour change.",
      categories: ["scar-treatment", "acne-scarring", "origin-laser", "skin-rejuvenation", "redness", "pigmentation"],
      keywords: ["scar", "scarring", "keloid", "raised scar", "scar texture", "scar colour", "wound"],
      confidence: ["Scar type", "Raised or flat", "Scar age", "Skin tone", "Healing history"],
      covers: ["Keloid Scarring", "Scarring"],
      routes: ["Scar-type assessment", "Keloid-safe clinical route", "Texture and colour pathway"]
    },
    {
      id: "skin-reactive",
      area: "skin",
      label: "Sensitive, inflamed or reactive skin",
      copy: "Eczema, psoriasis, itching, inflammation, sensitivity and impaired skin barrier.",
      categories: ["eczema", "psoriasis", "redness", "rosacea", "wound-healing", "personalised-skincare", "skin-rejuvenation"],
      keywords: ["sensitive", "sensitivity", "inflamed", "inflammation", "reactive", "eczema", "psoriasis", "itching", "itchy", "barrier", "wound healing"],
      confidence: ["Symptoms and triggers", "Inflammation", "Skin barrier", "Medical history", "Suitability"],
      covers: ["Eczema", "Inflammation", "Psoriasis", "Wound Healing"],
      routes: ["Inflammatory skin assessment", "Barrier-support pathway", "Doctor-led skin route"]
    },
    {
      id: "skin-changing",
      area: "skin",
      label: "Ageing, hormonal or changing skin",
      copy: "Collagen, elasticity or dryness changes, including perimenopausal, menopausal and male skin needs.",
      categories: ["personalised-skincare", "skin-rejuvenation", "profhilo-skin-booster", "polynucleotides", "prp-microneedling", "origin-laser"],
      keywords: ["ageing skin", "collagen", "elasticity", "sagging", "hormonal skin", "perimenopause", "perimenopausal", "menopause", "menopausal", "male skin", "dryness"],
      confidence: ["Life-stage changes", "Collagen and elasticity", "Dryness", "Hormonal context", "Skin goals"],
      covers: ["Anti-Ageing", "Collagen Loss", "Elasticity Loss", "Male Skin", "Menopausal Skin", "Perimenopausal Skin", "Sagging", "Wrinkles"],
      routes: ["Changing-skin assessment", "Personalised skincare pathway", "Collagen and skin-quality route"]
    },
    {
      id: "ageing",
      area: "face",
      label: "Ageing, lines and collagen change",
      copy: "Forehead, frown and smile lines, collagen loss, laxity and facial volume change.",
      categories: ["anti-wrinkle", "skin-rejuvenation", "under-eye-treatment", "hifu-facelift", "polynucleotides", "profhilo-skin-booster", "prp-microneedling", "transformations"],
      keywords: ["age", "ageing", "wrinkle", "forehead", "frown lines", "crow's feet", "smile lines", "lines", "natural", "collagen", "volume loss", "fresh", "not overdone"],
      confidence: ["Movement lines", "Collagen loss", "Skin laxity", "Volume change", "Expression"],
      covers: ["Anti-Ageing", "Collagen Loss", "Elasticity Loss", "Sagging", "Volume Loss", "Wrinkles"],
      routes: ["Ageing pattern assessment", "Movement-softening route", "Collagen and skin quality route"]
    },
    {
      id: "eyes",
      area: "face",
      label: "Tired eyes, brows or eyelids",
      copy: "Dark circles, bags, puffiness, hollowness, fine lines and brow or eyelid heaviness.",
      categories: ["under-eye-treatment", "tear-trough-fillers", "polynucleotides", "skin-rejuvenation", "anti-wrinkle", "hifu-facelift"],
      keywords: ["under eye", "under-eye", "eyes", "tired", "dark circles", "eye bags", "puffiness", "tear trough", "brow", "eyelid", "fresh"],
      confidence: ["Under-eye support", "Skin quality", "Shadowing or puffiness", "Brow and eyelid area", "Suitability"],
      covers: ["Dark Circles", "Eye Bags"],
      routes: ["Under-eye suitability check", "Skin quality route", "Doctor-led eye assessment"]
    },
    {
      id: "definition",
      area: "face",
      label: "Definition, jawline or profile",
      copy: "Jawline, chin, cheeks, double chin or neck fat, profile and facial balance.",
      categories: ["jawline-fillers", "chin-fillers", "cheek-fillers", "jawline-reduction-tmj", "non-surgical-rhinoplasty", "transformations"],
      keywords: ["jaw", "jawline", "chin", "double chin", "neck fat", "cheeks", "profile", "definition", "balance", "filler"],
      confidence: ["Profile balance", "Jawline", "Chin or neck fat", "Cheeks", "Facial structure"],
      covers: ["Fat Reduction", "Sun Damage", "Volume Loss"],
      routes: ["Facial balance assessment", "Structure route", "Natural definition plan"]
    },
    {
      id: "lips-smile",
      area: "face",
      label: "Lips, mouth or smile",
      copy: "Lip shape, volume or colour, lip lines, gummy smile and lines around the mouth.",
      categories: ["lip-fillers", "lip-dissolving", "perioral-fillers", "marionette-line-fillers", "nasolabial-fold-fillers", "gummy-smile-treatment", "anti-wrinkle", "semi-permanent-makeup"],
      keywords: ["lips", "lip filler", "lip lines", "lip colour", "gummy smile", "mouth", "marionette", "nasolabial", "perioral", "downturned mouth", "smile"],
      confidence: ["Lip and smile goals", "Natural proportions", "Movement", "Previous treatment", "Suitability"],
      covers: ["Dehydrated Skin", "Volume Loss", "Wrinkles"],
      routes: ["Lip and smile assessment", "Perioral balance route", "Natural lip pathway"]
    },
    {
      id: "nose-profile",
      area: "face",
      label: "Nose shape, lines or profile",
      copy: "Nose profile, bunny lines, a drooping tip, nasal flare and non-surgical nose shaping.",
      categories: ["non-surgical-rhinoplasty", "anti-wrinkle", "transformations"],
      keywords: ["nose", "nose shape", "nose profile", "bunny lines", "nasal droop", "drooping tip", "nasal flare", "rhinoplasty"],
      confidence: ["Nose profile", "Movement lines", "Tip and nostril movement", "Medical history", "High-risk-area suitability"],
      covers: ["Scarring", "Wrinkles"],
      routes: ["Doctor-led nose assessment", "Nose movement route", "Non-surgical profile pathway"]
    },
    {
      id: "jaw-tension",
      area: "face",
      label: "Jaw or neck tension and facial slimming",
      copy: "Masseter bulk, clenching or grinding, lower-face slimming, chin dimpling and trapezius tension.",
      categories: ["jawline-reduction-tmj", "jawline-fillers", "chin-fillers", "anti-wrinkle", "traptox", "transformations"],
      keywords: ["jaw tension", "neck tension", "trapezius", "traptox", "clenching", "grinding", "bruxism", "masseter", "tmj", "facial slimming", "jawline reduction", "chin dimpling"],
      confidence: ["Jaw or neck symptoms", "Clenching pattern", "Masseter or trapezius activity", "Facial balance", "Clinical suitability"],
      covers: ["Pain", "Fat Reduction"],
      routes: ["Jaw-tension assessment", "Masseter suitability route", "Lower-face balance pathway"]
    },
    {
      id: "lifting-neck",
      area: "face",
      label: "Jowls, lifting or neck changes",
      copy: "Sagging jowls, brow or face lifting, neck laxity, neck lines and platysmal bands.",
      categories: ["hifu-facelift", "neck-tightening", "nefertiti-neck-lift", "platysmal-band", "anti-wrinkle", "skin-rejuvenation", "polynucleotides", "prp-microneedling", "transformations"],
      keywords: ["jowls", "sagging jowls", "lift", "facelift", "brow lift", "jaw lift", "neck lift", "neck lines", "neck wrinkles", "nefertiti", "platysmal bands", "laxity"],
      confidence: ["Lift priority", "Skin laxity", "Jowls", "Neck and bands", "Treatment depth"],
      covers: ["Anti-Ageing", "Collagen Loss", "Elasticity Loss", "Sagging", "Wrinkles"],
      routes: ["Face-and-neck assessment", "Lifting and tightening route", "Neck and platysmal pathway"]
    },
    {
      id: "face-sweating",
      area: "face",
      label: "Face, nose or scalp sweating",
      copy: "Persistent sweating affecting the face, nose, hairline or scalp.",
      categories: [],
      keywords: ["face sweating", "facial sweating", "nose sweating", "scalp sweating", "hairline sweating", "hyperhidrosis", "excess sweating"],
      confidence: ["Sweating area", "Pattern and triggers", "Medical context", "Skin and scalp health", "Suitability"],
      covers: ["Excess Sweating"],
      routes: ["Facial-sweating assessment", "Area-specific sweating route", "Doctor-led suitability check"]
    },
    {
      id: "body-shaping",
      area: "body",
      label: "Stubborn fat or body contouring",
      copy: "Abdomen, flanks, arms, thighs, knees, back, hips or buttocks.",
      categories: ["body-contouring", "fat-reduction", "skin-tightening-body", "cellulite-removal"],
      keywords: ["body", "fat", "shape", "sculpting", "contouring", "abdomen", "flanks", "thighs", "arms"],
      confidence: ["Exact body area", "Fat distribution", "Skin quality", "Contouring goal", "Downtime"],
      routes: ["Body contouring assessment", "Localised fat pathway", "Area-specific sculpting route"]
    },
    {
      id: "body-tightening",
      area: "body",
      label: "Loose skin, cellulite or stretch marks",
      copy: "Laxity, post-weight-loss skin, cellulite, stretch marks and lifting.",
      categories: ["skin-tightening-body", "cellulite-removal", "stretch-marks", "body-contouring", "skin-rejuvenation"],
      keywords: ["body", "cellulite", "tightening", "loose skin", "laxity", "stretch marks", "weight loss"],
      confidence: ["Skin laxity", "Cellulite", "Stretch marks", "Area to assess", "Treatment depth"],
      routes: ["Body tightening assessment", "Cellulite pathway", "Stretch-mark and texture route"]
    },
    {
      id: "body-acne",
      area: "body",
      label: "Body acne, pimples or scarring",
      copy: "Chest, back or body breakouts, marks, pores and acne scarring.",
      categories: ["acne-treatment", "acne-scarring", "scar-treatment", "origin-laser", "skin-rejuvenation"],
      keywords: ["body acne", "bacne", "body pimples", "breakouts", "chest acne", "back acne", "scarring"],
      confidence: ["Active breakouts", "Body area", "Scarring", "Inflammation", "Skin barrier"],
      routes: ["Body acne assessment", "Breakout-control pathway", "Body scar and texture route"]
    },
    {
      id: "body-pigment",
      area: "body",
      label: "Body pigmentation, redness or visible vessels",
      copy: "Age spots, uneven pigment, redness, port-wine stains and vascular marks.",
      categories: ["pigmentation", "redness", "vascular-lesions", "origin-laser", "skin-rejuvenation"],
      keywords: ["body pigmentation", "age spots", "redness", "vascular", "port wine", "uneven tone", "marks"],
      confidence: ["Pigment type", "Vascular pattern", "Body area", "Skin tone", "Sun history"],
      routes: ["Body pigment assessment", "Vascular suitability route", "Tone and rejuvenation pathway"]
    },
    {
      id: "body-inflammatory",
      area: "body",
      label: "Eczema, psoriasis or inflammation",
      copy: "Inflamed, reactive, itchy or impaired body skin and wound-healing concerns.",
      categories: ["eczema", "psoriasis", "redness", "wound-healing", "skin-rejuvenation"],
      keywords: ["eczema", "psoriasis", "inflammation", "itchy", "reactive", "wound healing", "body skin"],
      confidence: ["Inflammation", "Skin barrier", "Body area", "Medical history", "Suitability"],
      routes: ["Inflammatory skin assessment", "Barrier-support route", "Doctor-led skin pathway"]
    },
    {
      id: "body-sweating",
      area: "body",
      label: "Excess sweating",
      copy: "Underarms, palms, soles, face, nose or scalp sweating.",
      categories: [],
      keywords: ["sweating", "hyperhidrosis", "underarms", "palms", "soles", "face sweating", "scalp sweating"],
      confidence: ["Sweating area", "Pattern and triggers", "Medical context", "Suitability", "Expected outcome"],
      routes: ["Hyperhidrosis assessment", "Area-specific sweating route", "Clinical suitability check"]
    },
    {
      id: "body-hair-removal",
      area: "body",
      label: "Unwanted body hair",
      copy: "Face, neck, arms, underarms, torso, back, legs or intimate areas.",
      categories: ["hair-removal-laser"],
      keywords: ["unwanted hair", "body hair", "laser hair removal", "underarms", "back hair", "leg hair"],
      confidence: ["Hair and skin type", "Exact area", "Growth pattern", "Laser suitability", "Course planning"],
      routes: ["Laser hair-removal assessment", "Area and skin-type route", "Course planning pathway"]
    },
    {
      id: "hair-thinning",
      area: "hair",
      label: "Hair loss, thinning or pattern baldness",
      copy: "Shedding, density, alopecia and male or female pattern change.",
      categories: ["hair-regrowth", "scalp-treatment", "prp-microneedling", "polynucleotides"],
      keywords: ["hair loss", "thinning", "density", "shedding", "regrowth", "alopecia", "pattern baldness"],
      confidence: ["Hair density", "Shedding pattern", "Pattern change", "Scalp health", "Regenerative suitability"],
      routes: ["Hair-loss assessment", "Regenerative scalp route", "Maintenance pathway"]
    },
    {
      id: "scalp-symptoms",
      area: "hair",
      label: "Dandruff, itching or scalp symptoms",
      copy: "Dry, oily or flaky scalp, eczema, psoriasis, pimples and seborrhoeic dermatitis.",
      categories: ["scalp-treatment", "eczema", "psoriasis", "hydrafacial", "prp-microneedling"],
      keywords: ["scalp", "dandruff", "itchy", "dry scalp", "oily scalp", "flaky", "eczema", "psoriasis", "pimples"],
      confidence: ["Scalp symptoms", "Inflammation", "Oil and flaking", "Medical history", "Scalp barrier"],
      routes: ["Scalp-condition assessment", "Scalp-cleansing route", "Inflammatory scalp pathway"]
    },
    {
      id: "hair-damage",
      area: "hair",
      label: "Damaged, dry or breaking hair",
      copy: "Breakage, poor hair condition, dryness and repair support.",
      categories: ["scalp-treatment", "hydrafacial", "hair-regrowth", "polynucleotides"],
      keywords: ["damaged hair", "dry hair", "hair breakage", "hair repair", "condition", "brittle"],
      confidence: ["Hair condition", "Breakage pattern", "Scalp support", "At-home care", "Clinical route"],
      routes: ["Hair-condition assessment", "Scalp and hair support route", "Repair and maintenance pathway"]
    },
    {
      id: "beard-brows",
      area: "hair",
      label: "Patchy beard or thinning eyebrows",
      copy: "Beard loss, eyebrow thinning, eyebrow hair loss or colour change.",
      categories: ["hair-regrowth", "scalp-treatment", "polynucleotides", "semi-permanent-makeup"],
      keywords: ["patchy beard", "beard loss", "eyebrow thinning", "eyebrow hair loss", "brows"],
      confidence: ["Hair-loss pattern", "Beard or brow area", "Skin health", "Regenerative suitability", "Cosmetic options"],
      routes: ["Beard and brow assessment", "Regenerative hair route", "Brow restoration pathway"]
    },
    {
      id: "excess-hair",
      area: "hair",
      label: "Excess or unwanted hair growth",
      copy: "Hirsutism or unwanted face, neck and body hair.",
      categories: ["hair-removal-laser"],
      keywords: ["excess hair", "hirsutism", "unwanted hair", "facial hair", "body hair", "laser"],
      confidence: ["Growth pattern", "Hair and skin type", "Exact area", "Hormonal context", "Laser suitability"],
      routes: ["Excess-hair assessment", "Laser suitability route", "Area-specific course planning"]
    },
    {
      id: "not-sure",
      area: "unsure",
      label: "I am not sure yet",
      copy: "A calm consultation-first starting point.",
      categories: ["transformations", "skin-rejuvenation", "origin-laser", "anti-wrinkle", "hydrafacial", "under-eye-treatment", "acne-treatment"],
      keywords: ["advice", "listen", "listened", "explain", "clear", "guidance", "recommend"],
      confidence: ["Goals clarified", "Suitability checked", "Options separated", "Pricing explained", "First route chosen"],
      routes: ["Guided consultation", "Doctor-led route finder", "Safest first plan"]
    }
  ];

  var PREFS = {
    natural: { label: "Natural-looking", keywords: ["natural", "not overdone", "subtle", "fresh"] },
    downtime: { label: "Low downtime", keywords: ["downtime", "quick", "recovery", "gentle"] },
    guidance: { label: "Need guidance", keywords: ["advice", "explain", "listened", "guided", "clear"] },
    stronger: { label: "Strongest suitable", keywords: ["result", "plan", "effective", "confidence"] }
  };

  var FLOW_STEPS = ["area", "concern", "preference", "route"];
  var AREA_FLOW_COPY = {
    skin: "Skin health, acne, pigment, pores, scars, sensitivity and changing skin.",
    face: "Lines, eyes, lips, nose, jaw, profile, lifting, neck and facial sweating.",
    body: "Body acne, scarring, pigment, inflammation, sweating, unwanted hair, shaping and tightening.",
    hair: "Hair loss, scalp symptoms, damage, beard or brow change and unwanted growth.",
    unsure: "A guided route when you do not want to self-diagnose."
  };

  var AREA_PROOF_CATEGORIES = {
    skin: [
      "skin-rejuvenation", "hydrafacial", "origin-laser", "personalised-skincare",
      "acne-treatment", "acne-scarring", "pigmentation", "redness", "rosacea",
      "vascular-lesions", "open-pore", "scar-treatment", "profhilo-skin-booster",
      "polynucleotides", "prp-microneedling", "eczema", "psoriasis", "wound-healing"
    ],
    face: [
      "anti-wrinkle", "under-eye-treatment", "tear-trough-fillers", "jawline-fillers",
      "chin-fillers", "cheek-fillers", "lip-fillers", "marionette-line-fillers",
      "lip-dissolving", "nasolabial-fold-fillers", "perioral-fillers", "neck-tightening",
      "nefertiti-neck-lift", "hifu-facelift", "non-surgical-rhinoplasty",
      "gummy-smile-treatment", "jawline-reduction-tmj", "skin-rejuvenation",
      "polynucleotides", "prp-microneedling", "platysmal-band", "traptox",
      "semi-permanent-makeup", "transformations"
    ],
    body: [
      "body-contouring", "fat-reduction", "cellulite-removal", "skin-tightening-body",
      "stretch-marks", "hair-removal-laser", "skin-rejuvenation"
    ],
    hair: [
      "hair-regrowth", "scalp-treatment", "prp-microneedling", "polynucleotides"
    ],
    unsure: [
      "skin-rejuvenation", "anti-wrinkle", "origin-laser", "hydrafacial",
      "under-eye-treatment", "acne-treatment", "pigmentation", "jawline-fillers",
      "hair-regrowth", "fat-reduction", "transformations"
    ]
  };

  var REVIEW_THEMES = [
    { id: "matched", label: "Most relevant", keywords: [] },
    { id: "natural", label: "Natural results", keywords: ["natural", "fresh", "not overdone", "subtle"] },
    { id: "clear", label: "Clear explanation", keywords: ["explain", "explained", "advice", "clear", "understand"] },
    { id: "listened", label: "Felt listened to", keywords: ["listen", "listened", "comfortable", "reassur", "nervous"] },
    { id: "google", label: "Google", keywords: [] },
    { id: "pabau", label: "Pabau", keywords: [] }
  ];

  // These starting-role rules mirror the clinic service map at concern level.
  // They guide the first consultation only; all roles remain available and the
  // clinician still confirms suitability before a treatment is discussed.
  var CONCERN_ROUTE_META = {
    healthier: { role: "practitioner", focus: "skin health", suitability: "skin quality, hydration, texture and barrier health" },
    acne: { role: "doctor", focus: "acne, breakouts or acne marks", suitability: "active breakouts, inflammation, acne marks, acne scarring and skin-barrier health" },
    pigment: { role: "doctor", focus: "pigmentation, redness or sun damage", suitability: "pigment pattern, melasma or sun damage, redness, skin tone and medical context" },
    "skin-congestion": { role: "doctor", focus: "pores, milia or congestion", suitability: "pore pattern, whiteheads or milia, congestion, skin texture and barrier health" },
    "skin-scarring": { role: "doctor", focus: "scars or keloid scarring", suitability: "scar type, whether it is raised or flat, healing history, skin tone and medical context" },
    "skin-reactive": { role: "doctor", focus: "sensitive, inflamed or reactive skin", suitability: "symptoms, inflammation, skin-barrier health, triggers and medical history" },
    "skin-changing": { role: "doctor", focus: "ageing, hormonal or changing skin", suitability: "life-stage changes, collagen and elasticity, dryness, hormonal context and skin goals" },
    ageing: { role: "nurse", focus: "lines and collagen change", suitability: "movement, collagen change, skin laxity and the areas that matter to you" },
    eyes: { role: "nurse", focus: "eye, brow or eyelid concerns", suitability: "skin quality, dark circles or puffiness, fine lines, brow or eyelid heaviness and under-eye suitability" },
    definition: { role: "nurse", focus: "facial definition", suitability: "facial balance, profile, jawline, chin and your natural-result goals" },
    "lips-smile": { role: "nurse", focus: "lips, mouth or smile", suitability: "lip and smile goals, movement, facial proportions, previous treatment and natural-result preferences" },
    "nose-profile": { role: "doctor", focus: "nose shape, lines or profile", suitability: "nose profile, movement, tip or nostril goals, medical history and high-risk-area suitability" },
    "jaw-tension": { role: "doctor", focus: "jaw or neck tension and facial slimming", suitability: "jaw or neck symptoms, clenching pattern, masseter or trapezius activity, facial balance and medical context" },
    "lifting-neck": { role: "nurse", focus: "jowls, lifting or neck changes", suitability: "skin laxity, jowls, neck lines or bands, the depth of change and your natural-result goals" },
    "face-sweating": { role: "doctor", focus: "face, nose or scalp sweating", suitability: "the sweating pattern, exact area, triggers, medical context and suitability" },
    "body-shaping": { role: "practitioner", focus: "body contouring", suitability: "the exact area, fat distribution, skin quality and your contouring goal" },
    "body-tightening": { role: "practitioner", focus: "body skin tightening or texture", suitability: "skin laxity, cellulite, stretch marks and the exact body area" },
    "body-acne": { role: "doctor", focus: "body acne or scarring", suitability: "active body breakouts, inflammation, scarring, the affected areas and skin-barrier health" },
    "body-pigment": { role: "nurse", focus: "body pigmentation or redness", suitability: "pigment type, vascular pattern, the affected area, skin tone and sun history" },
    "body-inflammatory": { role: "doctor", focus: "inflamed or reactive body skin", suitability: "inflammation, skin-barrier health, symptoms, medical history and the affected area" },
    "body-sweating": { role: "doctor", focus: "excess sweating", suitability: "the sweating pattern, affected areas, triggers, medical context and suitability" },
    "body-hair-removal": { role: "practitioner", focus: "unwanted body hair", suitability: "hair and skin type, growth pattern, the exact area and laser suitability" },
    "hair-thinning": { role: "doctor", focus: "hair loss or thinning", suitability: "hair density, shedding pattern, scalp health, medical context and regenerative suitability" },
    "scalp-symptoms": { role: "doctor", focus: "scalp symptoms", suitability: "inflammation, oil or flaking, scalp-barrier health, symptoms and medical history" },
    "hair-damage": { role: "doctor", focus: "damaged or breaking hair", suitability: "hair condition, breakage pattern, scalp support, medical context and home care" },
    "beard-brows": { role: "doctor", focus: "beard or eyebrow hair change", suitability: "the hair-loss pattern, skin health, the affected area and regenerative suitability" },
    "excess-hair": { role: "doctor", focus: "excess or unwanted hair growth", suitability: "growth pattern, hair and skin type, the exact area, hormonal context and laser suitability" },
    "not-sure": { role: "doctor", focus: "a guided starting point", suitability: "your goals, medical context, suitability, priorities and the safest place to begin" }
  };

  var CONCERN_CONFLICTS = [
    { ids: ["hair-thinning", "excess-hair"], label: "hair loss and excess hair growth need separate clinical context" },
    { ids: ["acne", "definition"], label: "active acne and facial-definition goals need to be staged safely" },
    { ids: ["skin-reactive", "definition"], label: "reactive skin and facial-definition goals need to be staged safely" },
    { ids: ["skin-reactive", "lips-smile"], label: "reactive skin and lip or smile goals need to be staged safely" },
    { ids: ["skin-reactive", "nose-profile"], label: "reactive skin and nose-profile goals need to be staged safely" },
    { ids: ["body-acne", "definition"], label: "active body acne and facial-definition goals span different clinical routes" },
    { ids: ["body-inflammatory", "body-shaping"], label: "inflammatory skin and body-contouring goals need to be assessed separately" },
    { ids: ["body-inflammatory", "body-tightening"], label: "inflammatory skin and body-tightening goals need to be staged safely" }
  ];

  var state = {
    area: "",
    concern: "",
    concerns: [],
    concernTouched: false,
    pref: "",
    prefs: [],
    flowStep: 0,
    proofCategory: "",
    proofIndex: 0,
    reviewTheme: "matched",
    note: "",
    selectionNotice: ""
  };

  var googleState = {
    loading: false,
    loaded: false,
    failed: false,
    stale: false,
    fullFeedAvailable: false,
    approvalPending: false,
    feedStatus: "places",
    totalCount: 0,
    place: null
  };
  var pabauState = { loading: false, loaded: false, failed: false, stale: false, reviews: [], totalCount: 187, averageRating: 4.99 };
  var availabilityState = { loading: false, loaded: false, failed: false, roles: {} };
  var modalStack = [];
  var suppressNextPopstate = false;
  var modalHistoryTimer = 0;
  var bookingState = { opened: false, complete: false, role: "", openedAt: 0 };
  var sessionId = "";
  var autoTimer = 0;
  var showAllConcerns = false;
  var externalProofCategory = "";
  var inlineProofContext = "";
  var matchedProofContext = "";
  var inlineProofWanted = false;
  var normalisedProofCache = null;
  var normalisedProofByKey = {};
  var heroProofSignature = "";
  var secondaryRenderScheduled = false;
  var deferredContentObserver = null;
  var deferredObserverTimer = 0;
  var deferredProofTimer = 0;
  var reviewVisibleLimit = 12;
  var REVIEW_PAGE_SIZE = 12;
  var reviewImpressions = {};
  var lastRouteViewSignature = "";
  var lastClinicianRecommendationSignature = "";
  var proofAssetState = {
    loading: false,
    loaded: !!(window.DR_SKNN_BNA_DATA && window.DrSknnProofStudio),
    failed: false,
    callbacks: []
  };

  function q(selector, scope) {
    return (scope || root).querySelector(selector);
  }

  function qa(selector, scope) {
    return Array.prototype.slice.call((scope || root).querySelectorAll(selector));
  }

  function clean(value, limit) {
    var text = value == null ? "" : String(value);
    text = text.replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim();
    return limit ? text.slice(0, limit) : text;
  }

  function escapeHtml(value) {
    return clean(value).replace(/[&<>"']/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char];
    });
  }

  function runWhenIdle(callback, timeout) {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(callback, { timeout: Number(timeout || 1800) });
    } else {
      window.setTimeout(callback, Math.min(Number(timeout || 900), 1200));
    }
  }

  function loadExternalScript(id, src, ready, callback, onError) {
    if (ready()) {
      callback();
      return;
    }
    var existing = document.getElementById(id);
    if (existing) {
      existing.addEventListener("load", callback, { once: true });
      existing.addEventListener("error", onError, { once: true });
      return;
    }
    var script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = callback;
    script.onerror = onError;
    document.head.appendChild(script);
  }

  function resetProofCache() {
    normalisedProofCache = null;
    normalisedProofByKey = {};
  }

  function flushProofAssetCallbacks() {
    var callbacks = proofAssetState.callbacks.slice(0);
    proofAssetState.callbacks = [];
    callbacks.forEach(function (callback) {
      try { callback(proofAssetState.loaded); } catch (_) {}
    });
  }

  function proofAssetsFailed() {
    proofAssetState.loading = false;
    proofAssetState.failed = true;
    flushProofAssetCallbacks();
    var mounts = qa("[data-v5-proof-library], [data-v5-matched-proof-mount]");
    mounts.forEach(function (mount) {
      mount.innerHTML = '<div class="dps-status" role="status"><strong>Results are temporarily unavailable.</strong><span>You can still choose a consultation while we restore the clinical-proof library.</span></div>';
    });
    track("proof_load_failed");
  }

  function ensureProofAssets(callback) {
    if (typeof callback === "function") proofAssetState.callbacks.push(callback);
    if (window.DR_SKNN_BNA_DATA && window.DrSknnProofStudio && typeof window.DrSknnProofStudio.mount === "function") {
      proofAssetState.loaded = true;
      proofAssetState.loading = false;
      proofAssetState.failed = false;
      resetProofCache();
      flushProofAssetCallbacks();
      return;
    }
    if (proofAssetState.loading || proofAssetState.failed) return;
    var dataSrc = clean(root.getAttribute("data-v5-proof-data-src"), 2000);
    var engineSrc = clean(root.getAttribute("data-v5-proof-engine-src"), 2000);
    if (!dataSrc || !engineSrc) {
      proofAssetsFailed();
      return;
    }
    proofAssetState.loading = true;
    loadExternalScript(
      "drsknn-v5-proof-data-js",
      dataSrc,
      function () { return !!window.DR_SKNN_BNA_DATA; },
      function () {
        loadExternalScript(
          "drsknn-v5-proof-engine-js",
          engineSrc,
          function () { return !!(window.DrSknnProofStudio && typeof window.DrSknnProofStudio.mount === "function"); },
          function () {
            proofAssetState.loading = false;
            proofAssetState.loaded = true;
            proofAssetState.failed = false;
            resetProofCache();
            applyExternalProofContext();
            flushProofAssetCallbacks();
            renderResult();
            scheduleSecondaryRender();
          },
          proofAssetsFailed
        );
      },
      proofAssetsFailed
    );
  }

  function sessionIdentifier() {
    if (sessionId) return sessionId;
    try {
      sessionId = window.sessionStorage.getItem("drsknn_v5_session") || "";
      if (!sessionId) {
        sessionId = "v5-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 9);
        window.sessionStorage.setItem("drsknn_v5_session", sessionId);
      }
    } catch (_) {
      sessionId = "v5-" + Date.now().toString(36);
    }
    return sessionId;
  }

  function saveState() {
    try {
      window.sessionStorage.setItem(STATE_STORAGE_KEY, JSON.stringify({
        area: state.area,
        concern: state.concern,
        concerns: state.concerns,
        prefs: state.prefs,
        note: state.note
      }));
    } catch (_) {}
  }

  function restoreState() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(STATE_STORAGE_KEY) || "null");
      if (!stored || typeof stored !== "object") return;
      state.area = AREA_LABELS[stored.area] ? stored.area : "";
      state.concerns = Array.isArray(stored.concerns) ? stored.concerns : [];
      state.concern = clean(stored.concern, 80);
      state.prefs = Array.isArray(stored.prefs) ? stored.prefs.filter(function (id) { return !!PREFS[id]; }).slice(0, 4) : [];
      state.pref = state.prefs[0] || "";
      state.note = clean(stored.note, 1800);
      normaliseConcernSelection();
    } catch (_) {}
  }

  function applyExternalProofContext() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var area = clean(params.get("proof_area"), 20).toLowerCase();
      var categoryKey = clean(params.get("proof_category"), 100).toLowerCase().replace(/_/g, "-").replace(/[^a-z0-9-]/g, "");
      if (!state.area && AREA_LABELS[area]) state.area = area;
      if (categoryKey) externalProofCategory = categoryKey;
    } catch (_) {}
  }

  function bnaData() {
    return window.DR_SKNN_BNA_DATA || {};
  }

  function category(key) {
    var data = bnaData();
    if (data.categories && data.categories[key]) return data.categories[key];
    return data[key] || null;
  }

  function categoryTitle(key) {
    var cat = category(key);
    return clean((cat && (cat.title || cat.label)) || key.replace(/-/g, " "));
  }

  function categoryImages(key) {
    if (window.DrSknnProofStudio && typeof window.DrSknnProofStudio.normalizeLibrary === "function") {
      if (!normalisedProofCache) {
        normalisedProofCache = window.DrSknnProofStudio.normalizeLibrary();
        normalisedProofByKey = {};
        normalisedProofCache.forEach(function (entry) {
          normalisedProofByKey[entry.key] = entry;
        });
      }
      var normalised = normalisedProofByKey[key];
      if (normalised) {
        return normalised.items.map(function (item) {
          return Object.assign({}, item, {
            title: normalised.title,
            subtitle: normalised.subtitle
          });
        });
      }
    }
    var cat = category(key);
    if (!cat) return [];
    var images = cat.images || cat.items || [];
    return images.map(function (item, index) {
      item = typeof item === "string" ? { src: item } : (item || {});
      var firstSrc = item.src || item.after || item.before || "";
      var explicitType = clean(item.media || item.type).toLowerCase();
      var type = item.before && item.after ? "comparison" : (explicitType === "video" || /\.(mp4|mov|m4v|webm)(\?|$)/i.test(firstSrc) ? "video" : "image");
      return {
        key: key,
        title: categoryTitle(key),
        subtitle: clean(cat.subtitle || cat.description || ""),
        type: type,
        src: firstSrc,
        before: item.before || "",
        after: item.after || "",
        poster: item.poster || item.thumbnail || (type === "video" ? "" : firstSrc),
        alt: clean(item.alt || item.afterAlt || item.beforeAlt || categoryTitle(key)),
        caption: clean(item.caption || cat.subtitle || categoryTitle(key)),
        index: index
      };
    }).filter(function (item) {
      return !!item.src || (!!item.before && !!item.after);
    });
  }

  function selectedConcern() {
    return concernById(state.concern);
  }

  function concernById(id) {
    return CONCERNS.filter(function (item) { return item.id === id; })[0] || null;
  }

  function concernsForArea(area) {
    if (!area) return CONCERNS.slice(0);
    if (area === "unsure") return CONCERNS.filter(function (item) { return item.area === "unsure"; });
    return CONCERNS.filter(function (item) { return item.area === area; });
  }

  function normaliseConcernSelection() {
    var available = CONCERNS.map(function (item) { return item.id; });
    var selected = Array.isArray(state.concerns) ? state.concerns.slice(0) : [];
    if (state.concern && selected.indexOf(state.concern) === -1) selected.unshift(state.concern);
    selected = selected.filter(function (id, index) {
      return available.indexOf(id) !== -1 && selected.indexOf(id) === index;
    }).slice(0, 3);
    state.concerns = selected;
    state.concern = selected[0] || "";
    return selected;
  }

  function selectedConcernIds() {
    return normaliseConcernSelection().slice(0);
  }

  function selectedConcernModels() {
    return selectedConcernIds().map(concernById).filter(Boolean);
  }

  function resetConcernsForArea(area) {
    state.area = area;
    showAllConcerns = false;
    if (area === "unsure") {
      state.concerns = ["not-sure"];
      state.concern = "not-sure";
      state.concernTouched = true;
    }
    state.proofIndex = 0;
    state.proofCategory = "";
    saveState();
  }

  function toggleConcernSelection(id) {
    if (!concernById(id)) return selectedConcernIds();
    var selected = selectedConcernIds();
    var index = selected.indexOf(id);
    if (index !== -1) {
      selected.splice(index, 1);
    } else if (selected.length < 3) {
      selected.push(id);
    } else {
      state.selectionNotice = "You can attach up to three concerns. Remove one before adding another.";
      return selected;
    }
    state.selectionNotice = "";
    state.concerns = selected;
    state.concern = selected[0] || "";
    state.concernTouched = true;
    state.proofIndex = 0;
    state.proofCategory = "";
    saveState();
    return selected;
  }

  function selectedPrefIds() {
    var selected = Array.isArray(state.prefs) ? state.prefs.slice(0) : [];
    if (state.pref && selected.indexOf(state.pref) === -1) selected.unshift(state.pref);
    selected = selected.filter(function (id, index) {
      return !!PREFS[id] && selected.indexOf(id) === index;
    }).slice(0, 4);
    state.prefs = selected;
    state.pref = selected[0] || "";
    return selected;
  }

  function togglePreference(id) {
    if (!PREFS[id]) return selectedPrefIds();
    var selected = selectedPrefIds();
    var index = selected.indexOf(id);
    if (index === -1) selected.push(id);
    else selected.splice(index, 1);
    state.prefs = selected;
    state.pref = selected[0] || "";
    saveState();
    return selected;
  }

  function secondaryConcerns() {
    return selectedConcernModels().slice(1);
  }

  function selectedConcernSummary() {
    var selected = selectedConcernModels();
    if (!selected.length) return "Your consultation";
    if (selected.length === 1) return selected[0].label;
    return selected[0].label + " + " + selected.slice(1).map(function (item) { return item.label; }).join(" + ");
  }

  function joinLabels(labels) {
    var cleanLabels = labels.filter(Boolean);
    if (!cleanLabels.length) return "";
    if (cleanLabels.length === 1) return cleanLabels[0];
    if (cleanLabels.length === 2) return cleanLabels[0] + " and " + cleanLabels[1];
    return cleanLabels.slice(0, -1).join(", ") + " and " + cleanLabels[cleanLabels.length - 1];
  }

  function secondaryConcernSummary() {
    return joinLabels(secondaryConcerns().map(function (item) { return item.label; }));
  }

  function uniqueValues(values) {
    var seen = {};
    return values.filter(function (value) {
      value = clean(value, 120);
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function concernRouteMeta(concern) {
    return CONCERN_ROUTE_META[concern && concern.id] || {
      role: "doctor",
      focus: concern ? concern.label.toLowerCase() : "a guided starting point",
      suitability: "your goals, medical context, suitability and the safest place to begin"
    };
  }

  function routeAssessment() {
    var selected = selectedConcernModels();
    var ids = selected.map(function (item) { return item.id; });
    var areas = uniqueValues(selected.map(function (item) { return item.area; }).filter(function (area) { return area !== "unsure"; }));
    var roles = uniqueValues(selected.map(function (item) { return concernRouteMeta(item).role; }));
    var conflicts = CONCERN_CONFLICTS.filter(function (rule) {
      return rule.ids.every(function (id) { return ids.indexOf(id) !== -1; });
    }).map(function (rule) { return rule.label; });
    var mixed = areas.length > 1 || roles.length > 1;
    var role = !selected.length || conflicts.length || mixed ? "doctor" : (roles[0] || "doctor");
    var complexity = conflicts.length ? "conflict" : mixed ? "mixed" : selected.length > 1 ? "multiple" : selected.length ? "single" : "guided";
    var rationale;
    if (!selected.length) {
      rationale = "A doctor is the safest first point when you would like guidance without choosing a concern.";
    } else if (conflicts.length) {
      rationale = "A doctor is the safest first point because " + joinLabels(conflicts) + ".";
    } else if (mixed) {
      rationale = "A doctor is the safest first point because your selections cross " + (areas.length > 1 ? "more than one area" : "different clinician pathways") + ".";
    } else if (role === "nurse") {
      rationale = "A nurse is a suitable first assessment route for the focus you selected.";
    } else if (role === "practitioner") {
      rationale = "A qualified practitioner is a suitable first assessment route for the focus you selected.";
    } else {
      rationale = "A doctor is the safest first assessment route for the clinical context you selected.";
    }
    return {
      role: role,
      complexity: complexity,
      mixed: mixed,
      conflicts: conflicts,
      rationale: rationale
    };
  }

  function clinicianRoleLabel(role) {
    if (role === "practitioner") return "Qualified practitioner";
    return role === "nurse" ? "Nurse" : "Doctor";
  }

  function routeCode() {
    var assessment = routeAssessment();
    var selected = selectedConcernModels();
    var areas = uniqueValues(selected.map(function (item) { return item.area; }).filter(function (area) { return area !== "unsure"; }));
    var areaCode = areas.length > 1 ? "mixed" : (areas[0] || state.area || "guided");
    return ["v5", areaCode, assessment.complexity, assessment.role].join("_");
  }

  function focusLabels() {
    return selectedConcernModels().map(function (item) { return concernRouteMeta(item).focus; });
  }

  function personalisedPlanTitle() {
    var labels = focusLabels();
    return labels.length ? "Your " + joinLabels(labels) + " consultation plan" : "Your guided consultation plan";
  }

  function personalisedPlanCopy() {
    var selected = selectedConcernModels();
    if (!selected.length) {
      return "You do not need to self-diagnose. We’ll clarify your goals, check suitability and explain the safest place to begin.";
    }
    var primary = concernRouteMeta(selected[0]).focus;
    var extras = selected.slice(1).map(function (item) { return concernRouteMeta(item).focus; });
    var copy = "We’ll assess " + primary + " first";
    if (extras.length) copy += ", while also considering " + joinLabels(extras);
    copy += ".";
    if (selectedPrefIds().length) copy += " You asked us to prioritise " + preferencePhrase() + ".";
    return copy;
  }

  function preferenceClinicCard() {
    var ids = selectedPrefIds();
    if (!ids.length) {
      return {
        title: "Recovery and expectations",
        copy: "We’ll explain recovery, likely downtime and realistic expectations for every suitable route before you decide."
      };
    }
    var statements = ids.map(function (id) {
      if (id === "natural") return "keep natural-looking outcomes central";
      if (id === "downtime") return "prioritise appropriate lower-disruption routes and explain recovery";
      if (id === "guidance") return "give you clear comparisons and decision support";
      return "keep stronger suitable routes visible only after assessment";
    });
    return {
      title: ids.length === 1 ? "Your " + PREFS[ids[0]].label.toLowerCase() + " preference" : "Your consultation preferences",
      copy: "You asked us to " + joinLabels(statements) + "."
    };
  }

  function personalisedClinicCards() {
    var selected = selectedConcernModels();
    var primary = selected[0] || null;
    var assessment = routeAssessment();
    var preferenceIds = selectedPrefIds();
    var answerParts = [];
    if (primary) answerParts.push("Main focus: " + concernRouteMeta(primary).focus);
    if (selected.length > 1) answerParts.push("Also discuss: " + joinLabels(selected.slice(1).map(function (item) { return concernRouteMeta(item).focus; })));
    if (preferenceIds.length) answerParts.push("Preferences: " + joinLabels(preferenceIds.map(function (id) { return PREFS[id].label.toLowerCase(); })));
    if (clean(state.note, 1800)) answerParts.push("Your optional note");
    return [
      {
        title: primary ? "Suitability for your concerns" : "Suitability for your goals",
        copy: "We’ll assess " + (primary ? concernRouteMeta(primary).suitability : "your goals, medical context and the area you would like help with") + "."
      },
      {
        title: "Pricing for suitable routes",
        copy: primary
          ? "Pricing for any suitable " + concernRouteMeta(primary).focus + " route will be explained before you choose anything."
          : "Any suitable options and their prices will be explained before you choose anything."
      },
      preferenceClinicCard(),
      {
        title: "Your safest starting clinician",
        copy: clinicianRoleLabel(assessment.role) + " is highlighted as the starting point. " + assessment.rationale
      },
      {
        title: "Your answers are attached",
        copy: answerParts.length ? answerParts.join(". ") + "." : "Your guided-consultation request will be attached to the booking."
      }
    ];
  }

  function analyticsExternalPayload(detail) {
    var source = Object.assign({}, detail || {});
    var assessment = routeAssessment();
    var allowed = [
      "role", "selected_role", "recommended_role", "modal", "step", "theme",
      "depth", "reason", "expanded", "visible", "deposit", "consultation_fee",
      "seconds_open", "destination", "match_tier", "review_id", "source_kind"
    ];
    var payload = {
      route_code: routeCode(),
      route_complexity: assessment.complexity,
      recommended_role: assessment.role,
      viewport: window.innerWidth + "x" + window.innerHeight,
      device: window.innerWidth <= 760 ? "mobile" : window.innerWidth <= 1100 ? "tablet" : "desktop"
    };
    allowed.forEach(function (key) {
      var value = source[key];
      if (value === undefined || value === null || value === "") return;
      payload[key] = typeof value === "string" ? clean(value, 120) : value;
    });
    return payload;
  }

  function mergedConfidence() {
    var seen = {};
    var out = [];
    selectedConcernModels().forEach(function (concern) {
      concern.confidence.forEach(function (item) {
        if (seen[item]) return;
        seen[item] = true;
        out.push(item);
      });
    });
    return out.slice(0, 8);
  }

  function proofCategories() {
    var preferred = [];
    selectedConcernModels().forEach(function (concern) {
      concern.categories.forEach(function (key) {
        preferred.push(key);
      });
    });
    (AREA_PROOF_CATEGORIES[state.area] || []).forEach(function (key) {
      preferred.push(key);
    });
    var direct = uniqueCategoryKeys(preferred);
    if (window.DrSknnProofStudio && typeof window.DrSknnProofStudio.relatedCategoryKeys === "function") {
      window.DrSknnProofStudio.relatedCategoryKeys(state.area, direct).forEach(function (key) {
        preferred.push(key);
      });
    }
    return uniqueCategoryKeys(preferred);
  }

  function directProofCategories() {
    var preferred = [];
    if (externalProofCategory) preferred.push(externalProofCategory);
    selectedConcernModels().forEach(function (concern) {
      concern.categories.forEach(function (key) { preferred.push(key); });
    });
    if (!preferred.length) preferred = (AREA_PROOF_CATEGORIES[state.area] || []).slice(0, 6);
    return uniqueCategoryKeys(preferred, false);
  }

  function hasCategoryImages(key) {
    return !!category(key) && categoryImages(key).length > 0;
  }

  function uniqueCategoryKeys(keys, allowFallback) {
    var seen = {};
    var primary = [];
    var broad = [];
    keys.forEach(function (key) {
      if (!key || seen[key] || !hasCategoryImages(key)) return;
      seen[key] = true;
      if (key === "transformations") broad.push(key);
      else primary.push(key);
    });
    if (!primary.length && !broad.length && allowFallback !== false) {
      ["skin-rejuvenation", "anti-wrinkle", "origin-laser", "hydrafacial", "transformations"].forEach(function (key) {
        if (!seen[key] && hasCategoryImages(key)) {
          seen[key] = true;
          if (key === "transformations") broad.push(key);
          else primary.push(key);
        }
      });
    }
    return primary.concat(broad);
  }

  function itemUniqueKey(item) {
    return item.after || item.src || item.before || item.key + "|" + item.index;
  }

  function interleavedProofItems(keys, perCategoryLimit, limit) {
    var buckets = keys.map(function (key) {
      return categoryImages(key).slice(0, perCategoryLimit || 10);
    }).filter(function (bucket) {
      return bucket.length;
    });
    var seen = {};
    var out = [];
    var depth = 0;
    var keepGoing = true;
    while (keepGoing && (!limit || out.length < limit)) {
      keepGoing = false;
      buckets.forEach(function (bucket) {
        var item = bucket[depth];
        if (!item || (limit && out.length >= limit)) return;
        keepGoing = true;
        var unique = itemUniqueKey(item);
        if (!unique || seen[unique]) return;
        seen[unique] = true;
        out.push(item);
      });
      depth += 1;
    }
    return out;
  }

  function proofItems(limit) {
    return interleavedProofItems(proofCategories(), 16, limit);
  }

  function track(name, detail) {
    var firstPartyPayload = Object.assign({}, detail || {});
    firstPartyPayload.concern = state.concern;
    firstPartyPayload.concerns = selectedConcernIds().join(",");
    firstPartyPayload.area = state.area;
    firstPartyPayload.preference = state.pref;
    firstPartyPayload.preferences = selectedPrefIds().join(",");
    firstPartyPayload.session_id = sessionIdentifier();
    firstPartyPayload.route_code = routeCode();
    firstPartyPayload.viewport = window.innerWidth + "x" + window.innerHeight;
    firstPartyPayload.device = window.innerWidth <= 760 ? "mobile" : window.innerWidth <= 1100 ? "tablet" : "desktop";
    var externalPayload = analyticsExternalPayload(detail);
    var eventName = "drsknn_v5_" + name;
    try {
      window.DRSKNN_V5_EVENTS = Array.isArray(window.DRSKNN_V5_EVENTS) ? window.DRSKNN_V5_EVENTS : [];
      window.DRSKNN_V5_EVENTS.push({ event: eventName, drsknn_v5: firstPartyPayload, timestamp: Date.now() });
      if (!window.dataLayer || typeof window.dataLayer.push !== "function") window.dataLayer = [];
      window.dataLayer.push({ event: eventName, drsknn_v5: externalPayload });
      if (typeof window.gtag === "function") window.gtag("event", eventName, externalPayload);
      window.dispatchEvent(new CustomEvent("drsknn:v5-analytics", { detail: { event: eventName, payload: externalPayload } }));
    } catch (_) {}
  }

  function trackRouteResultView() {
    var signature = routeCode() + "|" + selectedConcernIds().join("|") + "|" + selectedPrefIds().join("|");
    if (signature === lastRouteViewSignature) return;
    lastRouteViewSignature = signature;
    track("route_result_view", { route_code: routeCode(), recommended_role: routeAssessment().role });
  }

  function trackClinicianRecommendation() {
    var assessment = routeAssessment();
    var signature = routeCode() + "|" + assessment.role;
    if (signature === lastClinicianRecommendationSignature) return;
    lastClinicianRecommendationSignature = signature;
    track("clinician_recommendation_shown", {
      recommended_role: assessment.role,
      route_complexity: assessment.complexity
    });
  }

  function renderAreas() {
    qa("[data-v5-area]").forEach(function (btn) {
      btn.classList.toggle("is-active", btn.getAttribute("data-v5-area") === state.area);
    });
    var areaLabel = q("[data-v5-area-label]");
    if (areaLabel) areaLabel.textContent = AREA_LABELS[state.area] || "Choose an area";
  }

  function renderConcerns() {
    var grid = q("[data-v5-concern-grid]");
    if (!grid) return;
    if (!state.area) {
      grid.innerHTML = '<div class="drsknn-v5-empty drsknn-v5-console-empty"><strong>Choose an area to begin</strong><span>Skin, face, body, hair or a guided consultation.</span></div>';
      return;
    }
    var concerns = concernsForArea(state.area);
    var selected = normaliseConcernSelection();
    grid.innerHTML = concerns.map(function (item) {
      var selectedIndex = selected.indexOf(item.id);
      var active = selectedIndex !== -1 ? " is-active" : "";
      var badge = selectedIndex === 0 ? '<em class="drsknn-v5-selected-badge">Main focus</em>' : selectedIndex > 0 ? '<em class="drsknn-v5-selected-badge">Also mention</em>' : "";
      return '<button class="drsknn-v5-choice' + active + '" type="button" data-v5-concern="' + escapeHtml(item.id) + '" aria-pressed="' + (selectedIndex !== -1 ? "true" : "false") + '"><span class="drsknn-v5-choice-head"><strong>' + escapeHtml(item.label) + '</strong>' + badge + '</span><small>' + escapeHtml(AREA_LABELS[item.area] || item.area) + '</small><span>' + escapeHtml(item.copy) + '</span></button>';
    }).join("");
  }

  function renderPrefs() {
    var selected = selectedPrefIds();
    qa("[data-v5-pref]").forEach(function (btn) {
      var active = selected.indexOf(btn.getAttribute("data-v5-pref")) !== -1;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function renderResult() {
    var concern = selectedConcern();
    var hasRoute = !!concern;
    var title = q("[data-v5-result-title]");
    var copy = q("[data-v5-result-copy]");
    var confidence = q("[data-v5-confidence]");
    var proofHeading = q("[data-v5-proof-heading]");
    var proofCopy = q("[data-v5-proof-copy]");
    var directCategories = directProofCategories();
    var startingCategory = directCategories[0] ? categoryTitle(directCategories[0]) : "";
    if (title) title.textContent = personalisedPlanTitle() + ".";
    if (copy) copy.textContent = personalisedPlanCopy();
    if (proofHeading) proofHeading.textContent = "All clinical proof, in one place.";
    if (proofCopy) proofCopy.textContent = startingCategory
      ? "Based on your current choices, we started with " + startingCategory + ". Every published result remains available below through the area filters and category search."
      : "Browse every published Dr Sknn before-and-after result here. Filter by area, search any category and enlarge individual cases without leaving this page.";
    if (confidence) {
      confidence.innerHTML = personalisedClinicCards().map(function (item) {
        return '<div class="drsknn-v5-handoff-item"><strong>' + escapeHtml(item.title) + '</strong><span>' + escapeHtml(item.copy) + '</span></div>';
      }).join("");
    }
  }

  function setCaption(item) {
    var title = q("[data-v5-hero-proof-title]");
    var subtitle = q("[data-v5-hero-proof-subtitle]");
    if (title) title.textContent = item ? item.title : "Relevant clinic examples";
    if (subtitle) subtitle.textContent = item
      ? (selectedConcern() ? "Part of your wider route" : "Across skin, face, body and hair")
      : "Matched to what you select";
  }

  function heroProofItems() {
    return proofItems(18).filter(function (item) {
      return item.type !== "video" || !!item.poster;
    }).slice(0, 8);
  }

  function renderHeroProof() {
    var stage = q("[data-v5-hero-proof-stage]");
    if (!stage) return;
    var caption = q(".drsknn-v5-proof-caption", stage);
    var items = heroProofItems();
    if (!items.length) {
      qa("[data-v5-hero-proof-image]", stage).forEach(function (img) { img.remove(); });
      heroProofSignature = "";
      setCaption(null);
      return;
    }
    if (state.proofIndex >= items.length) state.proofIndex = 0;
    var signature = items.map(itemUniqueKey).join("|");
    if (signature !== heroProofSignature) {
      qa("[data-v5-hero-proof-image]", stage).forEach(function (img) { img.remove(); });
      items.forEach(function (item, index) {
        var img = document.createElement("img");
        img.src = item.poster || item.after || item.src;
        img.alt = item.alt;
        img.loading = index === 0 ? "eager" : "lazy";
        img.decoding = "async";
        img.setAttribute("data-v5-hero-proof-image", "");
        img.className = index === state.proofIndex ? "is-active" : "";
        stage.insertBefore(img, caption || null);
      });
      heroProofSignature = signature;
    } else {
      qa("[data-v5-hero-proof-image]", stage).forEach(function (img, index) {
        img.classList.toggle("is-active", index === state.proofIndex);
      });
    }
    setCaption(items[state.proofIndex]);
  }

  function advanceProof(delta) {
    var stage = q("[data-v5-hero-proof-stage]");
    if (!stage || stage.offsetParent === null) return;
    var items = heroProofItems();
    if (!items.length) return;
    state.proofIndex = (state.proofIndex + delta + items.length) % items.length;
    renderHeroProof();
  }

  function renderProofSection() {
    if (inlineProofWanted) mountInlineProofLibrary(false);
  }

  function reviewThemesForConcern() {
    return REVIEW_THEMES;
  }

  function googleReviews() {
    var place = googleState.place || {};
    var reviews = (place.reviews || []).map(function (review, index) {
      var rating = Math.max(1, Math.min(5, Math.round(Number(review.rating || 5))));
      var reviewText = clean(review.text || review.comment || "", 1400);
      return {
        id: clean(review.id || review.review_id || review.reviewId || review.time || ("google-" + index), 120),
        source: "Google",
        sourceKind: "google",
        author: clean(review.author_name || review.author || review.reviewer || "Google reviewer", 70),
        rating: rating,
        text: reviewText || ("Rating-only Google review: " + rating + " out of 5."),
        date: clean(review.date || review.relative_time_description || review.update_time || review.time || "Google review", 80),
        service: "",
        tags: {
          concerns: normaliseReviewTagArray(review.tags && (review.tags.concern_ids || review.tags.concerns)),
          areas: normaliseReviewTagArray(review.tags && (review.tags.area_ids || review.tags.areas)),
          categories: normaliseReviewTagArray(review.tags && (review.tags.category_ids || review.tags.categories)),
          roles: normaliseReviewTagArray(review.tags && (review.tags.clinician_roles || review.tags.roles)),
          preferences: normaliseReviewTagArray(review.tags && (review.tags.preference_tags || review.tags.preferences))
        },
        url: clean(review.url || review.google_maps_uri || place.googleMapsUri || GOOGLE_REVIEWS_URL, 1200) || GOOGLE_REVIEWS_URL
      };
    });
    return reviews;
  }

  function pabauReviews() {
    return pabauState.reviews;
  }

  function allReviews() {
    return googleReviews().concat(pabauReviews());
  }

  function valuesIntersect(left, right) {
    return left.some(function (value) { return right.indexOf(value) !== -1; });
  }

  function hasDirectReviewConcern(concern, concernTags, areaTags) {
    if (!concern) return false;
    if (concernTags.indexOf(concern.id) !== -1) return true;
    var aliases = {
      "body-acne": ["acne"],
      "body-pigment": ["pigment", "pigmentation"],
      "body-inflammatory": ["eczema", "psoriasis", "inflammation"],
      "body-hair-removal": ["body-hair-removal", "excess-hair"],
      "hair-thinning": ["hair-loss", "hair-thinning"]
    };
    var supported = aliases[concern.id] || [];
    return areaTags.indexOf(concern.area) !== -1 && valuesIntersect(concernTags, supported);
  }

  function reviewMatch(review) {
    var concerns = selectedConcernModels();
    var primary = concerns[0] || null;
    var secondary = concerns.slice(1);
    var theme = REVIEW_THEMES.filter(function (item) { return item.id === state.reviewTheme; })[0] || REVIEW_THEMES[0];
    if (theme.id === "google" && review.sourceKind !== "google") return { score: -1000, tier: "filtered", reason: "" };
    if (theme.id === "pabau" && review.sourceKind !== "pabau") return { score: -1000, tier: "filtered", reason: "" };
    var tags = review.tags || {};
    var concernTags = Array.isArray(tags.concerns) ? tags.concerns : [];
    var areaTags = Array.isArray(tags.areas) ? tags.areas : [];
    var categoryTags = Array.isArray(tags.categories) ? tags.categories : [];
    var preferenceTags = Array.isArray(tags.preferences) ? tags.preferences : [];
    var text = (review.text + " " + review.service + " " + review.author).toLowerCase();
    var score = 0;
    var tier = "general";
    var reason = "General clinic experience";
    if (primary && hasDirectReviewConcern(primary, concernTags, areaTags)) {
      score += 120;
      tier = "direct";
      reason = "Direct match to " + concernRouteMeta(primary).focus;
    } else if (primary && valuesIntersect(categoryTags, primary.categories)) {
      score += 48;
      tier = "related";
      reason = "Related to " + concernRouteMeta(primary).focus;
    }
    secondary.some(function (concern) {
      var exactConcern = hasDirectReviewConcern(concern, concernTags, areaTags);
      var relatedCategory = valuesIntersect(categoryTags, concern.categories);
      if (!exactConcern && !relatedCategory) return false;
      score += exactConcern ? 72 : 36;
      if (tier !== "direct") {
        tier = "related";
        reason = "Related to " + concernRouteMeta(concern).focus;
      }
      return true;
    });
    if (state.area && areaTags.indexOf(state.area) !== -1) {
      score += 34;
      if (tier === "general") {
        tier = "area";
        reason = "Relevant to your selected " + state.area + " area";
      }
    }
    if (primary) primary.keywords.forEach(function (word) {
      if (text.indexOf(word.toLowerCase()) !== -1) score += 10;
    });
    secondary.forEach(function (concern) {
      concern.keywords.forEach(function (word) {
        if (text.indexOf(word.toLowerCase()) !== -1) score += 6;
      });
    });
    selectedPrefIds().forEach(function (pref) {
      if (preferenceTags.indexOf(pref) !== -1) {
        score += 28;
        if (tier === "general") {
          tier = "preference";
          reason = "Matched to your " + PREFS[pref].label.toLowerCase() + " preference";
        }
      }
      (PREFS[pref] ? PREFS[pref].keywords : []).forEach(function (word) {
        if (text.indexOf(word.toLowerCase()) !== -1) score += 4;
      });
    });
    theme.keywords.forEach(function (word) {
      if (text.indexOf(word.toLowerCase()) !== -1) score += 4;
    });
    if (tier === "general" && primary && primary.keywords.some(function (word) { return text.indexOf(word.toLowerCase()) !== -1; })) {
      tier = "related";
      reason = "Relevant wording about " + concernRouteMeta(primary).focus;
    }
    if (review.sourceKind === "pabau" && review.service) score += 2;
    return { score: score, tier: tier, reason: reason };
  }

  function balanceReviewSources(reviews) {
    if (state.reviewTheme === "google" || state.reviewTheme === "pabau") return reviews;
    var google = reviews.filter(function (review) { return review.sourceKind === "google"; });
    var pabau = reviews.filter(function (review) { return review.sourceKind === "pabau"; });
    if (!google.length || !pabau.length) return reviews;
    var first = google;
    var second = pabau;
    if ((pabau[0]._match || {}).score > (google[0]._match || {}).score) {
      first = pabau;
      second = google;
    }
    var balanced = [];
    var size = Math.max(first.length, second.length);
    for (var index = 0; index < size; index += 1) {
      if (first[index]) balanced.push(first[index]);
      if (second[index]) balanced.push(second[index]);
    }
    return balanced;
  }

  function matchedReviews(limit) {
    var scored = allReviews().map(function (review) {
      return { review: review, match: reviewMatch(review) };
    }).filter(function (item) {
      return item.match.score > -1000;
    }).sort(function (a, b) {
      return b.match.score - a.match.score;
    }).map(function (item) {
      return Object.assign({}, item.review, { _match: item.match });
    });
    scored = balanceReviewSources(scored);
    return typeof limit === "number" ? scored.slice(0, limit) : scored;
  }

  function trackReviewImpressions(reviews) {
    reviews.forEach(function (review) {
      var match = review._match || reviewMatch(review);
      var key = clean(review.sourceKind + "-" + review.id + "-" + match.tier, 240);
      if (!key || reviewImpressions[key]) return;
      reviewImpressions[key] = true;
      track("review_impression", {
        review_id: clean(review.id, 120),
        match_tier: match.tier,
        source_kind: review.sourceKind
      });
    });
  }

  function renderReviewSection() {
    var tabs = q("[data-v5-review-tabs]");
    var grid = q("[data-v5-review-grid]");
    if (tabs) {
      tabs.innerHTML = reviewThemesForConcern().map(function (theme) {
        var active = theme.id === state.reviewTheme ? " is-active" : "";
        return '<button class="drsknn-v5-chip' + active + '" type="button" data-v5-review-theme="' + escapeHtml(theme.id) + '">' + escapeHtml(theme.label) + '</button>';
      }).join("");
    }
    if (!grid) return;
    var reviews = matchedReviews(6);
    if (!reviews.length) {
      grid.innerHTML = state.reviewTheme === "pabau" ? pabauLaunchCardHtml() : sourceReviewCardsHtml();
      return;
    }
    grid.innerHTML = reviews.map(reviewCardHtml).join("") + (pabauReviews().length || state.reviewTheme === "google" ? "" : pabauLaunchCardHtml());
    trackReviewImpressions(reviews);
  }

  function sourceReviewCardsHtml() {
    var googleCopy = googleState.loading ? "Loading actual review text from the clinic review service." : googleState.failed ? "The live Google text could not be loaded here. Open the source profile." : "Open the live Google profile to read current Google reviews.";
    var pabauCopy = pabauState.loading ? "Checking the verified Pabau review source." : pabauState.failed ? "Verified Pabau text is not currently returned to this page. Open Pabau directly." : "Open verified Pabau patient feedback for service-led review detail.";
    return [
      '<button class="drsknn-v5-review-card" type="button" data-v5-review-source-link="' + escapeHtml(GOOGLE_REVIEWS_URL) + '"><span class="drsknn-v5-review-source">Google</span><strong>5.0 Google Reviews</strong><p>' + escapeHtml(googleCopy) + '</p><span>Live source</span></button>',
      '<button class="drsknn-v5-review-card" type="button" data-v5-review-source-link="' + escapeHtml(PABAU_REVIEWS_URL) + '"><span class="drsknn-v5-review-source">Pabau</span><strong>4.99/5 Pabau Reviews</strong><p>' + escapeHtml(pabauCopy) + '</p><span>Verified patient source</span></button>'
    ].join("");
  }

  function reviewCardHtml(review) {
    var text = review.text.length > 260 ? review.text.slice(0, 257) + "..." : review.text;
    var rating = Math.max(1, Math.min(5, Math.round(Number(review.rating || 5))));
    var match = review._match || reviewMatch(review);
    var context = [review.service, review.date].filter(Boolean).join(" · ") || review.source;
    return '<article class="drsknn-v5-review-card" data-v5-review-card data-v5-review-id="' + escapeHtml(review.id) + '">' +
      '<span class="drsknn-v5-review-source">' + escapeHtml(review.source) + ' · ' + rating + '/5</span>' +
      '<span class="drsknn-v5-review-match drsknn-v5-review-match--' + escapeHtml(match.tier) + '">' + escapeHtml(match.reason) + '</span>' +
      '<strong>' + escapeHtml(review.author || "Verified patient") + '</strong>' +
      '<p data-v5-review-preview>' + escapeHtml(text) + '</p>' +
      '<p class="drsknn-v5-review-full" data-v5-review-full hidden>' + escapeHtml(review.text) + '</p>' +
      '<span>' + escapeHtml(context) + '</span>' +
      '<span class="drsknn-v5-review-actions"><button type="button" data-v5-review-expand>Read full review</button><button type="button" data-v5-review-source-link="' + escapeHtml(review.url || GOOGLE_REVIEWS_URL) + '">Open source</button></span>' +
    '</article>';
  }

  function pabauLaunchCardHtml() {
    return '<button class="drsknn-v5-review-card drsknn-v5-review-vault-card" type="button" data-v5-open-reviews="pabau"><span class="drsknn-v5-review-source">Pabau · verified patients</span><strong>Browse the full Pabau review vault</strong><p>Open the live Pabau feed inside V5 and continue through every review available from the verified patient source.</p><span>Open all Pabau reviews →</span></button>';
  }

  function reviewTabsHtml() {
    return '<div class="drsknn-v5-review-tabs">' + reviewThemesForConcern().map(function (theme) {
      var active = theme.id === state.reviewTheme ? " is-active" : "";
      return '<button class="drsknn-v5-chip' + active + '" type="button" data-v5-review-theme="' + escapeHtml(theme.id) + '">' + escapeHtml(theme.label) + '</button>';
    }).join("") + '</div>';
  }

  function googleReviewNoticeHtml(visibleCount) {
    var place = googleState.place || {};
    var total = Number(googleState.totalCount || place.user_ratings_total || place.userRatingCount || googleReviews().length || 81);
    if (googleState.fullFeedAvailable) {
      return '<div class="drsknn-v5-review-status"><span><strong>Full live Google Business Profile review feed</strong><small>Every public Google review is available inside V5 and refreshes safely from the clinic\'s verified profile.' + (googleState.stale ? ' The last safely cached version is shown while Google refreshes.' : '') + '</small></span><a class="drsknn-v5-btn drsknn-v5-btn-quiet" href="' + escapeHtml(GOOGLE_REVIEWS_URL) + '" target="_blank" rel="noopener">Open Google profile</a></div>' +
        '<p class="drsknn-v5-review-count" role="status">Showing ' + visibleCount + ' of ' + total + ' live Google reviews.</p>';
    }
    return '<div class="drsknn-v5-review-status"><span><strong>Google\'s full review feed is awaiting Business Profile API approval</strong><small>V5 is currently showing the five review texts Google Places permits. It will switch to every live Google review automatically as soon as Google approves the clinic project.</small></span><a class="drsknn-v5-btn drsknn-v5-btn-quiet" href="' + escapeHtml(GOOGLE_REVIEWS_URL) + '" target="_blank" rel="noopener">Read all ' + total + ' on Google</a></div>' +
      '<p class="drsknn-v5-review-count" role="status">Showing ' + visibleCount + ' of ' + total + ' Google reviews inside V5 while approval is pending.</p>';
  }

  function pabauReviewVaultHtml() {
    return '<div class="drsknn-v5-review-status"><span><strong>Full verified Pabau review feed</strong><small>The live source is loaded only when you open this tab, keeping the main V5 page fast.</small></span><a class="drsknn-v5-btn drsknn-v5-btn-quiet" href="' + escapeHtml(PABAU_REVIEWS_URL) + '" target="_blank" rel="noopener">Open Pabau separately</a></div>' +
      '<div class="drsknn-v5-pabau-vault"><iframe src="' + escapeHtml(PABAU_REVIEWS_URL) + '" loading="lazy" title="All verified Dr Sknn reviews on Pabau"></iframe></div>';
  }

  function pabauReviewNoticeHtml(visibleCount, totalCount) {
    var staleCopy = pabauState.stale ? " The last safely cached version is shown while the source refreshes." : "";
    return '<div class="drsknn-v5-review-status"><span><strong>Verified Pabau review index</strong><small>Showing public written feedback supplied by Pabau, with private patient fields excluded.' + escapeHtml(staleCopy) + '</small></span><a class="drsknn-v5-btn drsknn-v5-btn-quiet" href="' + escapeHtml(PABAU_REVIEWS_URL) + '" target="_blank" rel="noopener">Open original Pabau feed</a></div>' +
      '<p class="drsknn-v5-review-count" role="status">Showing ' + visibleCount + ' of ' + totalCount + ' indexed Pabau reviews.</p>';
  }

  function renderReviewModal() {
    var body = q("[data-v5-review-modal-body]");
    if (!body) return;
    if (state.reviewTheme === "pabau" && !pabauReviews().length) {
      body.innerHTML = reviewTabsHtml() + pabauReviewVaultHtml();
      return;
    }
    var reviews = matchedReviews();
    var visible = reviews.slice(0, reviewVisibleLimit);
    var cards = visible.length ? visible.map(reviewCardHtml).join("") : sourceReviewCardsHtml();
    if (state.reviewTheme !== "google" && !pabauReviews().length) cards += pabauLaunchCardHtml();
    var status = state.reviewTheme === "google"
      ? googleReviewNoticeHtml(visible.length)
      : state.reviewTheme === "pabau"
        ? pabauReviewNoticeHtml(visible.length, reviews.length)
        : '<p class="drsknn-v5-review-count" role="status">Showing ' + visible.length + ' of ' + reviews.length + ' available review texts, ranked by your answers and labelled by match strength.</p>';
    var more = reviews.length > visible.length
      ? '<div class="drsknn-v5-review-more"><button class="drsknn-v5-btn drsknn-v5-btn-quiet" type="button" data-v5-review-more>Show ' + Math.min(REVIEW_PAGE_SIZE, reviews.length - visible.length) + ' more reviews</button></div>'
      : "";
    body.innerHTML = reviewTabsHtml() + status + '<div class="drsknn-v5-review-grid">' + cards + '</div>' + more;
    trackReviewImpressions(visible);
  }

  function ensureReviewsForTheme() {
    if (state.reviewTheme === "google") {
      ensureGoogleReviews();
      return;
    }
    if (state.reviewTheme === "pabau") {
      ensurePabauReviews();
      return;
    }
    ensureGoogleReviews();
    ensurePabauReviews();
  }

  function refreshReviewDisplays() {
    scheduleSecondaryRender();
    if (q('[data-v5-modal="reviews"].is-open')) renderReviewModal();
  }

  function selectedPref() {
    return PREFS[state.pref] || null;
  }

  function preferencePhrase() {
    var phrases = selectedPrefIds().map(function (pref) {
      if (pref === "guidance") return "clear guidance";
      if (pref === "downtime") return "little downtime";
      if (pref === "stronger") return "the strongest suitable route";
      return "a natural-looking result";
    });
    return joinLabels(phrases) || "your priorities in clinic";
  }

  function flowStepIndex(step) {
    if (typeof step === "number") return Math.max(0, Math.min(FLOW_STEPS.length - 1, step));
    var index = FLOW_STEPS.indexOf(clean(step, 40));
    return index === -1 ? 0 : index;
  }

  function flowProgressHtml() {
    return '<div class="drsknn-v5-flow-progress" aria-hidden="true">' + FLOW_STEPS.map(function (_, index) {
      var klass = index < state.flowStep ? " is-complete" : index === state.flowStep ? " is-active" : "";
      return '<span class="' + klass + '"></span>';
    }).join("") + '</div>';
  }

  function flowMeta() {
    var step = FLOW_STEPS[state.flowStep];
    if (step === "area") {
      return {
        title: "Start with the area",
        subtitle: "This keeps the first click broad, so patients do not feel they are choosing a treatment alone."
      };
    }
    if (step === "concern") {
      return {
        title: "Choose up to 3 concerns",
        subtitle: "The first one is the main focus. Extra concerns are attached for the clinic and used to match proof."
      };
    }
    if (step === "preference") {
      return {
        title: "Tell us what would make this easier",
        subtitle: "This helps the clinic stage the safest route around comfort, downtime and expectation."
      };
    }
    return {
      title: personalisedPlanTitle(),
      subtitle: "Created from your answers. Nothing here diagnoses a condition or chooses a treatment before your consultation."
    };
  }

  function areaFlowHtml() {
    var keys = ["skin", "face", "body", "hair", "unsure"];
    return '<div class="drsknn-v5-flow-grid">' + keys.map(function (key) {
      var active = key === state.area ? " is-active" : "";
      var label = key === "unsure" ? "Not sure" : key.charAt(0).toUpperCase() + key.slice(1);
      return '<button class="drsknn-v5-flow-card' + active + '" type="button" data-v5-area="' + escapeHtml(key) + '"><strong>' + escapeHtml(label) + '</strong><span>' + escapeHtml(AREA_FLOW_COPY[key]) + '</span></button>';
    }).join("") + '</div>';
  }

  function concernFlowHtml() {
    var selected = normaliseConcernSelection();
    var recommended = concernsForArea(state.area);
    var other = CONCERNS.filter(function (item) { return recommended.indexOf(item) === -1; });
    var selectedOther = other.filter(function (item) { return selected.indexOf(item.id) !== -1; });
    var notice = state.selectionNotice ? '<p class="drsknn-v5-selection-notice" role="status">' + escapeHtml(state.selectionNotice) + '</p>' : '';
    function cards(items) {
      return '<div class="drsknn-v5-flow-grid">' + items.map(function (item) {
      var selectedIndex = selected.indexOf(item.id);
      var active = selectedIndex !== -1 ? " is-active" : "";
      var badge = selectedIndex === 0 ? '<em class="drsknn-v5-selected-badge">Main focus</em>' : selectedIndex > 0 ? '<em class="drsknn-v5-selected-badge">Also mention</em>' : "";
      return '<button class="drsknn-v5-flow-card' + active + '" type="button" data-v5-concern="' + escapeHtml(item.id) + '" aria-pressed="' + (selectedIndex !== -1 ? "true" : "false") + '"><span class="drsknn-v5-choice-head"><strong>' + escapeHtml(item.label) + '</strong>' + badge + '</span><small>' + escapeHtml(AREA_LABELS[item.area] || item.area) + '</small><span>' + escapeHtml(item.copy) + '</span></button>';
      }).join("") + '</div>';
    }
    var selectedOtherHtml = !showAllConcerns && selectedOther.length ? '<div class="drsknn-v5-flow-group"><div class="drsknn-v5-flow-group-head"><strong>Also selected</strong><span>From another area</span></div>' + cards(selectedOther) + '</div>' : '';
    var otherHtml = showAllConcerns ? '<div class="drsknn-v5-flow-group"><div class="drsknn-v5-flow-group-head"><strong>Other concerns</strong><span>Optional</span></div>' + cards(other) + '</div>' : '<button class="drsknn-v5-add-concerns" type="button" data-v5-show-all-concerns>Add another area or concern</button>';
    return '<div class="drsknn-v5-flow-help"><strong>Choose your main concern, then add up to two more if needed.</strong><span>It remains one consultation request. Your selections simply give the clinic better context.</span></div>' + notice + '<div class="drsknn-v5-flow-group"><div class="drsknn-v5-flow-group-head"><strong>Recommended for ' + escapeHtml(AREA_LABELS[state.area] || "your route") + '</strong><span>Start here</span></div>' + cards(recommended) + '</div>' + selectedOtherHtml + otherHtml;
  }

  function preferenceFlowHtml() {
    var descriptions = {
      natural: "Prioritise subtle, fresh and recognisable results.",
      downtime: "Show lower-disruption options first where suitable.",
      guidance: "Lean into explanation and doctor-led decision support.",
      stronger: "Keep stronger suitable routes visible after assessment."
    };
    var selected = selectedPrefIds();
    return '<div class="drsknn-v5-flow-help"><strong>Choose what matters to you.</strong><span>Optional. These guide the conversation; they do not choose a treatment.</span></div><div class="drsknn-v5-preference-list">' + Object.keys(PREFS).map(function (key) {
      var active = selected.indexOf(key) !== -1 ? " is-active" : "";
      return '<button class="drsknn-v5-preference' + active + '" type="button" data-v5-pref="' + escapeHtml(key) + '" aria-pressed="' + (active ? 'true' : 'false') + '"><span><strong>' + escapeHtml(PREFS[key].label) + '</strong><span>' + escapeHtml(descriptions[key]) + '</span></span></button>';
    }).join("") + '</div>' + (selected.length ? '<button class="drsknn-v5-clear-prefs" type="button" data-v5-clear-prefs>Clear preferences</button>' : '');
  }

  function confidenceChipsHtml(items) {
    return '<div class="drsknn-v5-flow-chips">' + items.map(function (item) {
      return '<span class="drsknn-v5-flow-chip">' + escapeHtml(item) + '</span>';
    }).join("") + '</div>';
  }

  function availabilityCopy(role) {
    var slot = availabilityState.roles[role] || {};
    if (slot.label) return "Next shown: " + clean(slot.label, 80) + ".";
    if (availabilityState.loading) return "Checking the live booking calendar.";
    if (role === "doctor") return "Doctor-led clinical planning. Check live times.";
    if (role === "nurse") return "Nurse assessment for suitable routes. Check live times.";
    return "Qualified skin, body and hair assessment. Check live times.";
  }

  function renderAvailabilityLabels() {
    qa("[data-v5-role-copy]").forEach(function (element) {
      element.textContent = availabilityCopy(element.getAttribute("data-v5-role-copy"));
    });
  }

  function renderNoteInputs() {
    qa("[data-v5-note]").forEach(function (element) {
      if (document.activeElement !== element && element.value !== state.note) element.value = state.note;
    });
  }

  function answerSummaryHtml() {
    var selected = selectedConcernModels();
    var prefs = selectedPrefIds().map(function (id) { return PREFS[id].label; });
    var areaLabels = uniqueValues(selected.map(function (item) {
      return (AREA_LABELS[item.area] || item.area).replace(" route", "");
    }));
    if (!areaLabels.length && state.area) areaLabels.push((AREA_LABELS[state.area] || state.area).replace(" route", ""));
    var rows = [
      {
        label: "Main focus",
        value: selected[0] ? selected[0].label : "Guidance without choosing a concern",
        step: "concern"
      },
      {
        label: "Also discuss",
        value: selected.length > 1 ? joinLabels(selected.slice(1).map(function (item) { return item.label; })) : "Nothing else selected",
        step: "concern"
      },
      {
        label: "Area",
        value: areaLabels.length ? joinLabels(areaLabels) : "Not selected",
        step: "area"
      },
      {
        label: "Preferences",
        value: prefs.length ? joinLabels(prefs) : "No preference selected",
        step: "preference"
      }
    ];
    return '<section class="drsknn-v5-answer-summary" aria-label="Your answers">' +
      '<div class="drsknn-v5-answer-summary-head"><strong>Your answers</strong><span>These travel with the booking.</span></div>' +
      '<dl>' + rows.map(function (row) {
        return '<div><dt>' + escapeHtml(row.label) + '</dt><dd>' + escapeHtml(row.value) + '</dd><button type="button" data-v5-edit-step="' + escapeHtml(row.step) + '" aria-label="Edit ' + escapeHtml(row.label) + '">Edit</button></div>';
      }).join("") +
      '<div><dt>Optional note</dt><dd data-v5-note-summary>' + escapeHtml(clean(state.note, 1800) || "None added") + '</dd><button type="button" data-v5-focus-note aria-label="Edit optional note">Edit</button></div>' +
      '</dl>' +
    '</section>';
  }

  function routeFlowHtml() {
    var selectedLabels = selectedConcernModels().map(function (item) { return item.label; });
    var routeCopy = personalisedPlanCopy() + " The clinic will confirm suitability, pricing and downtime before anything is chosen.";
    var clinicCards = personalisedClinicCards();
    var assessment = routeAssessment();
    return [
      '<div class="drsknn-v5-flow-split drsknn-v5-route-flow">',
        '<div class="drsknn-v5-flow-panel drsknn-v5-route-summary">',
          '<p class="drsknn-v5-kicker">Private clinical concierge</p>',
          '<h3>' + escapeHtml(personalisedPlanTitle()) + '.</h3>',
          '<p>' + escapeHtml(routeCopy) + '</p>',
          '<div class="drsknn-v5-route-concerns">' + selectedLabels.map(function (label) { return '<span>' + escapeHtml(label) + '</span>'; }).join("") + '</div>',
          '<div class="drsknn-v5-route-status">',
            '<span>Consultation is free</span>',
            '<span>£50 kiosk booking deposit</span>',
            '<span>Answers attached</span>',
          '</div>',
          '<div class="drsknn-v5-clinician-guidance"><span>Recommended starting point</span><strong>' + escapeHtml(clinicianRoleLabel(assessment.role)) + '</strong><p>' + escapeHtml(assessment.rationale) + ' This is not a diagnosis or treatment recommendation.</p></div>',
          answerSummaryHtml(),
          confidenceChipsHtml(mergedConfidence()),
          '<div class="drsknn-v5-flow-actions drsknn-v5-route-primary-actions">',
            '<button class="drsknn-v5-btn drsknn-v5-btn-primary" type="button" data-v5-open-consultation>Choose consultation</button>',
            '<button class="drsknn-v5-btn drsknn-v5-btn-quiet" type="button" data-v5-open-matched-proof>See matched proof</button>',
            '<button class="drsknn-v5-btn drsknn-v5-btn-quiet" type="button" data-v5-open-reviews="matched">Read matched reviews</button>',
          '</div>',
          '<div class="drsknn-v5-flow-note">',
            '<label class="drsknn-v5-mini" for="drsknn-v5-flow-note">Optional note attached before booking</label>',
            '<textarea id="drsknn-v5-flow-note" data-v5-note placeholder="E.g. I want a natural result, I am nervous, or I am not sure what suits me.">' + escapeHtml(state.note) + '</textarea>',
          '</div>',
        '</div>',
        '<aside class="drsknn-v5-flow-panel drsknn-v5-route-support">',
          '<p class="drsknn-v5-mini">Checked in clinic before treatment</p>',
          '<div class="drsknn-v5-handoff">' + clinicCards.map(function (item) {
            return '<div class="drsknn-v5-handoff-item"><strong>' + escapeHtml(item.title) + '</strong><span>' + escapeHtml(item.copy) + '</span></div>';
          }).join("") + '</div>',
          '<div class="drsknn-v5-deposit-summary">',
            '<span class="drsknn-v5-deposit-amount">£50</span>',
            '<span><strong>Kiosk booking deposit</strong><small>The doctor, nurse and qualified-practitioner consultations are free. The same deposit secures any route booked through the kiosk.</small></span>',
          '</div>',
        '</aside>',
      '</div>'
    ].join("");
  }

  function flowBodyHtml() {
    var step = FLOW_STEPS[state.flowStep];
    if (step === "area") return areaFlowHtml();
    if (step === "concern") return concernFlowHtml();
    if (step === "preference") return preferenceFlowHtml();
    return routeFlowHtml();
  }

  function renderFlow() {
    var meta = flowMeta();
    var title = q("[data-v5-flow-title]");
    var subtitle = q("[data-v5-flow-subtitle]");
    var body = q("[data-v5-flow-body]");
    var foot = q("[data-v5-flow-foot]");
    if (title) title.textContent = meta.title;
    if (subtitle) subtitle.textContent = meta.subtitle;
    if (body) body.innerHTML = flowProgressHtml() + flowBodyHtml();
    if (foot) {
      var leftLabel = state.flowStep < FLOW_STEPS.length - 1 ? "Step " + (state.flowStep + 1) + " of " + FLOW_STEPS.length : "Route ready";
      var left = '<span class="drsknn-v5-mini">' + leftLabel + '</span>';
      var back = state.flowStep > 0 ? '<button class="drsknn-v5-btn drsknn-v5-btn-quiet" type="button" data-v5-flow-prev>Back</button>' : '<button class="drsknn-v5-btn drsknn-v5-btn-quiet" type="button" data-v5-close>Close</button>';
      var stepName = FLOW_STEPS[state.flowStep];
      var blocked = (stepName === "area" && !state.area) || (stepName === "concern" && !selectedConcernIds().length);
      var guidance = blocked ? '<span class="drsknn-v5-flow-guidance" role="status">' + (stepName === "area" ? "Choose an area to continue." : "Choose at least one concern to continue.") + '</span>' : '';
      var next = state.flowStep < FLOW_STEPS.length - 1
        ? '<button class="drsknn-v5-btn drsknn-v5-btn-primary" type="button" data-v5-flow-next' + (blocked ? ' disabled aria-disabled="true"' : '') + '>Next step</button>'
        : '<button class="drsknn-v5-btn drsknn-v5-btn-primary" type="button" data-v5-open-consultation>Choose consultation</button>';
      foot.innerHTML = left + guidance + '<span class="drsknn-v5-flow-actions">' + back + next + '</span>';
    }
    if (FLOW_STEPS[state.flowStep] === "route") {
      trackRouteResultView();
      trackClinicianRecommendation();
    }
  }

  function openFlow(step) {
    state.flowStep = flowStepIndex(step);
    renderFlow();
    track("flow_open", { step: FLOW_STEPS[state.flowStep] });
    openModal("flow");
  }

  function consultationChooserHtml() {
    var selectedLabels = selectedConcernModels().map(function (item) { return item.label; });
    var assessment = routeAssessment();
    var cards = [
      ["doctor", "Doctor", "Doctor-led clinical planning and medical assessment."],
      ["nurse", "Nurse", "Nurse assessment for suitable clinical routes."],
      ["practitioner", "Qualified practitioner", "Skin, body and hair assessment with a qualified practitioner."]
    ].map(function (role) {
      var recommended = role[0] === assessment.role;
      return '<button class="drsknn-v5-route-card drsknn-v5-consultation-card' + (recommended ? ' is-recommended' : '') + '" type="button" data-v5-book="' + role[0] + '"' + (recommended ? ' aria-describedby="drsknn-v5-recommendation-copy"' : '') + '>' +
        '<span class="drsknn-v5-route-card-top"><strong>' + escapeHtml(role[1]) + '</strong><em>Free consultation</em></span>' +
        (recommended ? '<span class="drsknn-v5-route-recommended">Recommended starting point</span>' : '') +
        '<span>' + escapeHtml(role[2]) + '</span>' +
        '<span class="drsknn-v5-route-card-deposit">£50 kiosk booking deposit</span>' +
        '<span class="drsknn-v5-route-card-availability">' + escapeHtml(availabilityCopy(role[0])) + '</span>' +
      '</button>';
    }).join("");
    return '<div class="drsknn-v5-consultation-chooser">' +
      '<div class="drsknn-v5-consultation-summary">' +
        '<div><p class="drsknn-v5-kicker">Free consultation</p><h3>Choose who you would like to see.</h3><p>Doctor, nurse and qualified-practitioner consultations are free. A £50 deposit is taken to secure any booking made through the kiosk.</p><p class="drsknn-v5-recommendation-copy" id="drsknn-v5-recommendation-copy"><strong>' + escapeHtml(clinicianRoleLabel(assessment.role)) + ' is highlighted from your answers.</strong> ' + escapeHtml(assessment.rationale) + ' This is starting guidance only—not a diagnosis or treatment recommendation. You can still choose any clinician.</p></div>' +
        '<div class="drsknn-v5-deposit-badge"><strong>£50</strong><span>Kiosk booking deposit<br>for every route</span></div>' +
      '</div>' +
      (selectedLabels.length ? '<div class="drsknn-v5-route-concerns" aria-label="Concerns attached to booking">' + selectedLabels.map(function (label) { return '<span>' + escapeHtml(label) + '</span>'; }).join("") + '</div>' : '') +
      '<div class="drsknn-v5-consultation-grid">' + cards + '</div>' +
      '<p class="drsknn-v5-consultation-note"><strong>Clear before you continue:</strong> the consultation fee is £0 for every clinician route. The £50 payment is the kiosk booking deposit.</p>' +
    '</div>';
  }

  function renderConsultationChooser() {
    var body = q("[data-v5-consultation-body]");
    if (body) body.innerHTML = consultationChooserHtml();
  }

  function openConsultationChooser() {
    renderConsultationChooser();
    trackClinicianRecommendation();
    track("consultation_chooser_open", { deposit: 50, consultation_fee: 0, recommended_role: routeAssessment().role });
    openModal("consultation");
  }

  function modalName(modal) {
    return modal ? clean(modal.getAttribute("data-v5-modal"), 40) : "";
  }

  function syncModalStack() {
    modalStack = modalStack.filter(function (modal) { return modal && modal.classList.contains("is-open"); });
    modalStack.forEach(function (modal, index) {
      var top = index === modalStack.length - 1;
      modal.classList.toggle("is-under", !top);
      modal.setAttribute("aria-hidden", top ? "false" : "true");
      var dialog = q('[role="dialog"]', modal);
      if (dialog) dialog.setAttribute("aria-modal", top ? "true" : "false");
      modal.style.zIndex = String(10000 + index * 10);
      if (top) modal.removeAttribute("inert");
      else modal.setAttribute("inert", "");
    });
    Array.prototype.slice.call(root.children).forEach(function (child) {
      if (child.classList && child.classList.contains("drsknn-v5-modal")) return;
      if (modalStack.length) child.setAttribute("inert", "");
      else child.removeAttribute("inert");
    });
    document.body.classList.toggle("drsknn-v5-lock", modalStack.length > 0);
    updateStickyBookingBar();
  }

  function openModal(name, options) {
    var modal = q('[data-v5-modal="' + name + '"]');
    if (!modal) return;
    var alreadyOpen = modal.classList.contains("is-open");
    modal._v5RestoreFocus = document.activeElement;
    modal.classList.add("is-open");
    modalStack = modalStack.filter(function (item) { return item !== modal; });
    modalStack.push(modal);
    syncModalStack();
    if (!alreadyOpen && !(options && options.history === false)) {
      try {
        window.history.pushState({ drsknnV5Modal: name, drsknnV5Depth: modalStack.length }, "", window.location.href);
      } catch (_) {}
    }
    var focusTarget = q("[data-v5-close]", modal);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    track("modal_open", { modal: name, depth: modalStack.length });
  }

  function closeModalImmediate(modal, reason) {
    if (!modal) return;
    var name = modalName(modal);
    modal.classList.remove("is-open");
    modal.classList.remove("is-under");
    modal.removeAttribute("inert");
    modal.style.zIndex = "";
    modal.setAttribute("aria-hidden", "true");
    modalStack = modalStack.filter(function (item) { return item !== modal; });
    if (name === "booking" && bookingState.opened && !bookingState.complete) {
      track("booking_abandon", { role: bookingState.role, reason: reason || "close", seconds_open: Math.round((Date.now() - bookingState.openedAt) / 1000) });
      bookingState.opened = false;
    }
    if (name === "flow" && !bookingState.opened && !bookingState.complete) {
      track("route_abandon", { step: FLOW_STEPS[state.flowStep], reason: reason || "close" });
    }
    syncModalStack();
    var restore = modal._v5RestoreFocus;
    if (restore && document.contains(restore) && !restore.closest("[inert]")) {
      try { restore.focus({ preventScroll: true }); } catch (_) { restore.focus(); }
    } else if (modalStack.length) {
      var topClose = q("[data-v5-close]", modalStack[modalStack.length - 1]);
      if (topClose) topClose.focus({ preventScroll: true });
    }
    track("modal_close", { modal: name, reason: reason || "close", depth: modalStack.length });
  }

  function closeModal(modal, reason) {
    if (!modal) return;
    var top = modalStack[modalStack.length - 1];
    if (modal === top && window.history.state && window.history.state.drsknnV5Modal) {
      suppressNextPopstate = true;
      closeModalImmediate(modal, reason);
      try {
        window.history.back();
      } catch (_) {
        suppressNextPopstate = false;
      }
      if (modalHistoryTimer) window.clearTimeout(modalHistoryTimer);
      modalHistoryTimer = window.setTimeout(function () {
        suppressNextPopstate = false;
      }, 900);
      return;
    }
    closeModalImmediate(modal, reason);
  }

  function mountInlineProofLibrary(force) {
    var mount = q("[data-v5-proof-library]");
    var categories = directProofCategories();
    var context = categories.join("|") + "::" + (state.area || "");
    if (!mount) return null;
    if (!window.DrSknnProofStudio || typeof window.DrSknnProofStudio.mount !== "function") {
      inlineProofWanted = true;
      if (mount.getAttribute("data-v5-proof-awaiting") === "1") return null;
      mount.setAttribute("data-v5-proof-awaiting", "1");
      ensureProofAssets(function (loaded) {
        mount.removeAttribute("data-v5-proof-awaiting");
        if (loaded) mountInlineProofLibrary(force);
      });
      return null;
    }
    mount.removeAttribute("data-v5-proof-awaiting");
    if (!force && mount._drsknnProofStudio) {
      if (context !== inlineProofContext && typeof mount._drsknnProofStudio.setCategories === "function") {
        mount._drsknnProofStudio.setCategories(categories, state.area);
        inlineProofContext = context;
        track("proof_personalise", { categories: categories.join(",") });
      }
      return mount._drsknnProofStudio;
    }
    var api = window.DrSknnProofStudio.mount(mount, {
      mode: "library",
      compact: true,
      categoryKeys: categories,
      initialCategory: categories[0] || "",
      area: state.area,
      bookLabel: "Choose consultation",
      onBook: function (categoryKey, detail) {
        if (categoryKey && hasCategoryImages(categoryKey)) externalProofCategory = categoryKey;
        track("proof_consultation", detail || {});
        openConsultationChooser();
      },
      onEvent: function (name, detail) {
        if (name === "category_select" && detail && detail.category && hasCategoryImages(detail.category)) {
          externalProofCategory = detail.category;
        }
        track("proof_" + name, detail || {});
      }
    });
    inlineProofContext = context;
    return api;
  }

  function mountMatchedProofStudio(force) {
    var mount = q("[data-v5-matched-proof-mount]");
    var categories = directProofCategories();
    var context = categories.join("|") + "::" + (state.area || "");
    var hasPersonalisedRoute = categories.length > 0 || !!state.area || selectedConcernIds().length > 0;
    var subtitle = q("[data-v5-matched-proof-subtitle]");
    if (subtitle) {
      subtitle.textContent = hasPersonalisedRoute
        ? "Results closest to your selections, with related clinic proof available in the same window."
        : "A popular starting selection from the shared Dr Sknn clinical-proof library.";
    }
    if (!mount) return null;
    if (!window.DrSknnProofStudio || typeof window.DrSknnProofStudio.mount !== "function") {
      if (mount.getAttribute("data-v5-proof-awaiting") === "1") return null;
      mount.setAttribute("data-v5-proof-awaiting", "1");
      ensureProofAssets(function (loaded) {
        mount.removeAttribute("data-v5-proof-awaiting");
        if (loaded) mountMatchedProofStudio(force);
      });
      return null;
    }
    if (!force && mount._drsknnProofStudio) {
      if (context !== matchedProofContext && typeof mount._drsknnProofStudio.setCategories === "function") {
        mount._drsknnProofStudio.setCategories(categories, state.area);
        matchedProofContext = context;
      }
      return mount._drsknnProofStudio;
    }
    var api = window.DrSknnProofStudio.mount(mount, {
      mode: "matched",
      compact: true,
      categoryKeys: categories,
      area: state.area,
      directLabel: selectedConcern() ? "Matched to your main focus" : (hasPersonalisedRoute ? "Closest to your concerns" : "Popular across the clinic"),
      matchReason: function (item) {
        var key = clean(item && item.key, 120);
        var selected = selectedConcernModels();
        if (selected[0] && selected[0].categories.indexOf(key) !== -1) {
          return "Matched to your main focus: " + concernRouteMeta(selected[0]).focus + ".";
        }
        for (var index = 1; index < selected.length; index += 1) {
          if (selected[index].categories.indexOf(key) !== -1) {
            return "Matched to an additional concern: " + concernRouteMeta(selected[index]).focus + ".";
          }
        }
        if (state.area && (AREA_PROOF_CATEGORIES[state.area] || []).indexOf(key) !== -1) {
          return "Relevant to your selected " + state.area + " area.";
        }
        return "Related clinic proof. Photographs do not determine your suitability.";
      },
      bookLabel: "Choose consultation",
      onBook: function (categoryKey, detail) {
        if (categoryKey && hasCategoryImages(categoryKey)) externalProofCategory = categoryKey;
        track("matched_proof_consultation", detail || {});
        openConsultationChooser();
      },
      onEvent: function (name, detail) {
        if (name === "category_select" && detail && detail.category && hasCategoryImages(detail.category)) {
          externalProofCategory = detail.category;
        }
        track("matched_proof_" + name, detail || {});
      }
    });
    matchedProofContext = context;
    return api;
  }

  function openMatchedProofModal() {
    var categories = directProofCategories();
    track("matched_proof_open", { categories: categories.join(","), concerns: selectedConcernIds().join(",") });
    openModal("proof");
    mountMatchedProofStudio(false);
  }

  function closeModalsForInlineProof() {
    modalStack.slice(0).reverse().forEach(function (modal) {
      closeModalImmediate(modal, "proof_inline");
    });
    if (window.history.state && window.history.state.drsknnV5Modal) {
      try {
        window.history.replaceState({}, "", window.location.href);
      } catch (_) {}
    }
  }

  function openProofStudio() {
    var mount = q("[data-v5-proof-library]");
    var section = q("#drsknn-v5-proof");
    var categories = directProofCategories();
    inlineProofWanted = true;
    mountInlineProofLibrary(false);
    closeModalsForInlineProof();
    track("proof_open", { categories: categories.join(","), concerns: selectedConcernIds().join(","), destination: "inline_library" });
    if (section) {
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      section.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
    }
    window.setTimeout(function () {
      var focusTarget = mount && (q("[data-dps-search]", mount) || q("[data-dps-open-drawer]", mount));
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 420);
  }

  function openReviews(kind) {
    if (kind) {
      var nextTheme = kind === "matched" ? "matched" : kind;
      if (nextTheme !== state.reviewTheme) reviewVisibleLimit = REVIEW_PAGE_SIZE;
      state.reviewTheme = nextTheme;
    }
    ensureReviewsForTheme();
    renderReviewSection();
    renderReviewModal();
    track("reviews_open", { theme: state.reviewTheme });
    openModal("reviews");
  }

  function formatPabauDate(timestamp) {
    var value = Number(timestamp);
    if (!value) return "Pabau review";
    try {
      return new Date(value * 1000).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    } catch (_) {
      return "Pabau review";
    }
  }

  function normaliseReviewTagArray(value) {
    var values = Array.isArray(value) ? value : (typeof value === "string" ? value.split(",") : []);
    return uniqueValues(values.map(function (item) {
      return clean(item, 120).toLowerCase().replace(/_/g, "-").replace(/[^a-z0-9-]/g, "");
    }));
  }

  function expandReviewTags(values, aliases) {
    var expanded = values.slice(0);
    values.forEach(function (value) {
      (aliases[value] || []).forEach(function (alias) { expanded.push(alias); });
    });
    return uniqueValues(expanded);
  }

  function publicReviewLabel(value) {
    var candidate = value;
    if (candidate && typeof candidate === "object") {
      candidate = candidate.name || candidate.title || candidate.label || "";
    }
    if (typeof candidate !== "string" && typeof candidate !== "number") return "";
    var label = clean(candidate, 120);
    if (!label || /^[{[]/.test(label)) return "";
    return label;
  }

  function normalisePabauReview(review) {
    var tags = review && review.tags && typeof review.tags === "object" ? review.tags : {};
    var dateValue = review && (review.date || review.created_at || review.createdAt);
    var concernTags = normaliseReviewTagArray(tags.concerns || tags.concern_ids || tags.concern || (review && (review.concerns || review.concern_ids)));
    var areaTags = normaliseReviewTagArray(tags.areas || tags.area_ids || tags.area || (review && (review.areas || review.area_ids)));
    var preferenceTags = normaliseReviewTagArray(tags.preferences || tags.preference_tags || tags.experience || tags.experience_tags || (review && review.preference_tags));
    return {
      id: clean(review && (review.id || review.review_id), 120),
      source: "Pabau",
      sourceKind: "pabau",
      author: clean((review && (review.author || review.reviewer)) || "Verified patient", 80),
      rating: Number((review && review.rating) || 5),
      text: clean((review && (review.text || review.feedback)) || "", 1600),
      date: typeof dateValue === "string" ? clean(dateValue, 80) : formatPabauDate(dateValue),
      service: publicReviewLabel(review && review.service) || publicReviewLabel(review && review.category),
      tags: {
        concerns: expandReviewTags(concernTags, {
          "acne-scarring": ["acne"],
          "acne-treatment": ["acne"],
          "body-acne-scarring": ["body-acne"],
          "hair-loss": ["hair-thinning"],
          "hair-thinning": ["hair-thinning"],
          "excess-hair-growth": ["excess-hair"],
          "laser-hair-removal": ["body-hair-removal"]
        }),
        areas: expandReviewTags(areaTags, {
          "full-face": ["face"],
          "mid-face": ["face"],
          "under-eye": ["face"],
          "scalp": ["hair"],
          "chest": ["body"],
          "back": ["body"],
          "abdomen": ["body"],
          "arms": ["body"],
          "legs": ["body"]
        }),
        categories: normaliseReviewTagArray(tags.categories || tags.category_ids || tags.service_categories || tags.services || (review && (review.categories || review.category_ids))),
        roles: normaliseReviewTagArray(tags.roles || tags.clinician_roles || (review && review.clinician_roles)),
        preferences: expandReviewTags(preferenceTags, {
          "low-downtime": ["downtime"],
          "no-downtime": ["downtime"],
          "natural-looking": ["natural"],
          "clear-guidance": ["guidance"],
          "clear-explanation": ["guidance"],
          "listened-to": ["guidance"]
        })
      },
      // Pabau's public review vault does not guarantee a stable permalink for
      // each API review id. Keep "Open source" working by linking to the
      // verified clinic feed unless the safe server contract supplies a URL.
      url: clean(review && review.url, 1200) || PABAU_REVIEWS_URL
    };
  }

  function loadGoogleScript(callback) {
    if (window.google && window.google.maps && window.google.maps.places) {
      callback();
      return;
    }
    var existing = document.getElementById("drsknn-v5-google-places-js");
    if (existing) {
      existing.addEventListener("load", callback);
      existing.addEventListener("error", function () { googleState.failed = true; refreshReviewDisplays(); });
      return;
    }
    var script = document.createElement("script");
    script.id = "drsknn-v5-google-places-js";
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE_PLACES_API_KEY) + "&libraries=places&v=weekly&loading=async";
    script.async = true;
    script.defer = true;
    script.onload = callback;
    script.onerror = function () {
      googleState.loading = false;
      googleState.failed = true;
      refreshReviewDisplays();
    };
    document.head.appendChild(script);
  }

  function ensureGoogleReviews() {
    if (googleState.loading || googleState.loaded || googleState.failed) return;
    googleState.loading = true;
    function applyGooglePayload(payload) {
      if (!payload || payload.ok === false) throw new Error("Google review payload unavailable");
      var place = payload && payload.place ? payload.place : {};
      place.reviews = Array.isArray(payload && payload.reviews) ? payload.reviews : (place.reviews || []);
      place.user_ratings_total = Number(payload.rating_count || payload.total || payload.totalReviewCount || place.user_rating_count || place.user_ratings_total || place.userRatingCount || place.reviews.length || 0);
      googleState.loading = false;
      googleState.loaded = true;
      googleState.failed = false;
      googleState.stale = !!payload.stale;
      googleState.fullFeedAvailable = !!payload.full_feed_available;
      googleState.approvalPending = !!payload.approval_pending;
      googleState.feedStatus = clean(payload.status || payload.source || (googleState.fullFeedAvailable ? "business_profile" : "places"), 60);
      googleState.totalCount = place.user_ratings_total;
      googleState.place = place;
      var countEl = q("[data-v5-google-count]");
      if (countEl) countEl.textContent = googleState.totalCount + " live reviews";
      refreshReviewDisplays();
    }
    function fetchGoogleEndpoint(url) {
      return fetch(url, { mode: "cors", credentials: "omit" }).then(function (response) {
        if (!response.ok) throw new Error("Google review service failed");
        return response.json();
      }).then(applyGooglePayload);
    }
    fetchGoogleEndpoint(GOOGLE_REVIEWS_API_URL).catch(function () {
      return fetchGoogleEndpoint(GOOGLE_REVIEWS_FALLBACK_API_URL);
    }).catch(function () {
      googleState.loading = true;
      googleState.loaded = false;
      googleState.failed = false;
      googleState.fullFeedAvailable = false;
      googleState.approvalPending = true;
      loadGoogleScript(function () {
      try {
        var service = new google.maps.places.PlacesService(document.createElement("div"));
        service.getDetails({ placeId: GOOGLE_PLACE_ID, fields: ["name", "rating", "user_ratings_total", "reviews"] }, function (place, status) {
          googleState.loading = false;
          if (status === google.maps.places.PlacesServiceStatus.OK && place) {
            googleState.loaded = true;
            googleState.place = place;
            var count = Number(place.user_ratings_total || 80);
            googleState.totalCount = count;
            googleState.fullFeedAvailable = false;
            googleState.approvalPending = true;
            googleState.feedStatus = "browser_places";
            var countEl = q("[data-v5-google-count]");
            if (countEl) countEl.textContent = count + " live reviews";
          } else {
            googleState.failed = true;
          }
          refreshReviewDisplays();
        });
      } catch (_) {
        googleState.loading = false;
        googleState.failed = true;
        refreshReviewDisplays();
      }
      });
    });
  }

  function ensurePabauReviews() {
    if (pabauState.loading || pabauState.loaded || pabauState.failed) return;
    pabauState.loading = true;
    fetch(PABAU_REVIEWS_API_URL, { mode: "cors", credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("Pabau review service unavailable");
      return response.json();
    }).then(function (payload) {
      var reviews = Array.isArray(payload && payload.reviews) ? payload.reviews : [];
      pabauState.loading = false;
      pabauState.loaded = true;
      pabauState.stale = !!(payload && payload.stale);
      pabauState.totalCount = Number(payload.total || payload.total_count || payload.totalCount || reviews.length || pabauState.totalCount);
      pabauState.averageRating = Number(payload.average_rating || payload.averageRating || pabauState.averageRating);
      pabauState.reviews = reviews.map(normalisePabauReview).filter(function (review) { return !!review.text; });
      var countEl = q("[data-v5-pabau-count]");
      if (countEl) countEl.textContent = pabauState.totalCount + " verified reviews";
      refreshReviewDisplays();
    }).catch(function () {
      pabauState.loading = false;
      pabauState.failed = true;
      refreshReviewDisplays();
    });
  }

  function ensureAvailability() {
    if (availabilityState.loading || availabilityState.loaded || availabilityState.failed) return;
    availabilityState.loading = true;
    fetch(AVAILABILITY_API_URL, { mode: "cors", credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("Availability service failed");
      return response.json();
    }).then(function (payload) {
      availabilityState.loading = false;
      availabilityState.loaded = true;
      var source = (payload && (payload.roles || payload.slots || payload.availability)) || payload || {};
      ["doctor", "nurse", "practitioner"].forEach(function (role) {
        var raw = source[role] || source[role === "practitioner" ? "qualified_practitioner" : role] || {};
        availabilityState.roles[role] = {
          date: clean(raw.date, 40),
          time: clean(raw.time, 40),
          label: clean(raw.label || ([raw.date, raw.time].filter(Boolean).join(" ")), 80)
        };
      });
      if (q('[data-v5-modal="flow"].is-open') && FLOW_STEPS[state.flowStep] === "route") renderFlow();
      if (q('[data-v5-modal="consultation"].is-open')) renderConsultationChooser();
      renderAvailabilityLabels();
    }).catch(function () {
      availabilityState.loading = false;
      availabilityState.failed = true;
    });
  }

  function roleSlug(value) {
    var role = clean(value, 80).toLowerCase().replace(/_/g, "-");
    if (role === "doctor" || role === "nurse" || role === "practitioner") return role;
    return "doctor";
  }

  function providerRole(role) {
    return role === "practitioner" ? "qualified_practitioner" : role;
  }

  function attributionPayload() {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search || "");
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"].forEach(function (key) {
        var value = clean(params.get(key), 255);
        if (value) out[key] = value;
      });
    } catch (_) {}
    return out;
  }

  function bookingPayload(role) {
    var concern = selectedConcern();
    var selected = selectedConcernModels();
    var assessment = routeAssessment();
    var secondary = selected.slice(1).map(function (item) { return item.label; });
    var preferenceIds = selectedPrefIds();
    var preferenceLabels = preferenceIds.map(function (id) { return PREFS[id].label; });
    var hasAnswers = selected.length > 0 || preferenceIds.length > 0 || !!clean(state.note, 1800);
    var payload = {
      source: "v5",
      landing_source: "v5_route_finder",
      role: role,
      provider_role: providerRole(role),
      concern: concern ? concern.label : "",
      concern_cluster: selected.length ? selectedConcernSummary() : "No route answers supplied",
      primary_concern: concern ? concern.label : "",
      secondary_concerns: secondary.join(", "),
      goal: state.area ? (AREA_LABELS[state.area] || state.area) : "",
      priority: preferenceLabels.join(", "),
      goals: state.area || "",
      priorities: preferenceIds.join(","),
      result_title: personalisedPlanTitle(),
      route_code: routeCode(),
      route_complexity: assessment.complexity,
      recommended_clinician_role: assessment.role,
      recommendation_basis: "v5_concern_route_map",
      route_conflicts: assessment.conflicts.join("; "),
      route_label: "V5 Website Free " + (role === "practitioner" ? "Qualified Practitioner" : role.charAt(0).toUpperCase() + role.slice(1)) + " Consultation" + (hasAnswers ? " - Guided" : " - Direct"),
      consultation_fee: 0,
      kiosk_deposit: 50,
      payment_reason: "kiosk_booking_deposit",
      embedded_booking: "1",
      booking_embed: "v5_modal",
      hide_cookie_banner: "1",
      hide_cookie_notice: "1",
      hide_iubenda: "1",
      skip_cookie_policy: "1",
      website_cookie_consent_status: "handled_on_parent_site",
      website_cookie_consent_ref: "drsknn_com_v5_iubenda",
      patient_note: clean(state.note, 1800),
      selected_clicks: JSON.stringify({
        area: state.area,
        concern: state.concern,
        concerns: selectedConcernIds(),
        concern_labels: selected.map(function (item) { return item.label; }),
        preference: state.pref,
        preferences: preferenceIds,
        proof_categories: proofCategories(),
        confidence: mergedConfidence(),
        recommended_clinician_role: assessment.role,
        selected_clinician_role: role,
        route_complexity: assessment.complexity,
        conflicts: assessment.conflicts
      }),
      source_page: window.location.href
    };
    var attribution = attributionPayload();
    Object.keys(attribution).forEach(function (key) { payload[key] = attribution[key]; });
    return payload;
  }

  function consultationUrl(role) {
    return withBookingEmbedParams("https://www.drsknn.uk/kiosk/v4/consultation/" + encodeURIComponent(roleSlug(role)));
  }

  function withBookingEmbedParams(rawUrl) {
    var src = clean(rawUrl, 2000);
    if (!src) return "";
    try {
      var url = new URL(src, "https://www.drsknn.uk");
      var params = {
        source: "v5",
        landing_source: "v5_route_finder",
        embed: "1",
        embedded: "1",
        v5_embed: "1",
        booking_embed: "v5_modal",
        hide_cookie_banner: "1",
        hide_cookie_notice: "1",
        hide_iubenda: "1",
        skip_cookie_policy: "1",
        privacy_bypass: "1",
        kiosk_privacy_bypass: "1",
        cookie_consent: "accepted",
        consent: "accepted",
        iubenda_consent: "accepted",
        parent_domain: "drsknn.com",
        website_cookie_consent_status: "accepted_on_parent_site",
        website_cookie_consent_ref: "drsknn_com_v5_iubenda"
      };
      Object.keys(params).forEach(function (key) {
        url.searchParams.set(key, params[key]);
      });
      return url.toString();
    } catch (_) {
      return src;
    }
  }

  function openBooking(role, trigger) {
    var slug = roleSlug(role);
    var recommendedRole = routeAssessment().role;
    if (trigger) trigger.setAttribute("aria-busy", "true");
    if (slug !== recommendedRole) {
      track("clinician_recommendation_overridden", {
        recommended_role: recommendedRole,
        selected_role: slug
      });
    }
    track("booking_open", { role: slug });
    bookingState = { opened: true, complete: false, role: slug, openedAt: Date.now() };
    fetch("https://www.drsknn.uk/api/direct-booking/v4-triage", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bookingPayload(slug))
    }).then(function (response) {
      return response.ok ? response.json() : Promise.reject(new Error("triage_failed"));
    }).then(function (json) {
      var url = clean(json && json.url, 2000);
      if (url && url.charAt(0) === "/") url = "https://www.drsknn.uk" + url;
      setBookingFrame(withBookingEmbedParams(url || consultationUrl(slug)));
    }).catch(function () {
      setBookingFrame(consultationUrl(slug));
    }).finally(function () {
      if (trigger) trigger.removeAttribute("aria-busy");
    });
    openModal("booking");
  }

  function setBookingFrame(src) {
    var frame = q("[data-v5-booking-frame]");
    if (frame && frame.getAttribute("src") !== src) {
      frame.onload = function () {
        track("booking_iframe_loaded", { role: bookingState.role });
        try {
          frame.contentWindow.postMessage({
            type: "drsknn:parent-privacy-context",
            source: "drsknn.com",
            handled_on_parent_site: true,
            hide_embedded_cookie_notice: true
          }, "https://www.drsknn.uk");
        } catch (_) {}
      };
      frame.setAttribute("src", src);
    }
  }

  window.addEventListener("message", function (event) {
    var data = event && event.data;
    if (!data) return;
    if (data.type === "drsknn:v5-book") {
      openBooking(data.role || "doctor");
      return;
    }
    if (data.type === "drsknn:v5-proof-view") {
      track("proof_image_view", { index: Number(data.index || 0), category: clean(data.category, 100) });
      return;
    }
    if (data.type === "drsknn:v5-proof-zoom") {
      track("proof_zoom", { zoom: Number(data.zoom || 1) });
      return;
    }
    if (["drsknn:booking-complete", "drsknn:v5-booking-complete", "booking_complete", "booking-confirmed"].indexOf(data.type) !== -1) {
      bookingState.complete = true;
      bookingState.opened = false;
      track("booking_complete", { role: bookingState.role, booking_id: clean(data.booking_id || data.id, 120) });
    }
  });

  function renderAll() {
    renderAreas();
    renderConcerns();
    renderPrefs();
    renderResult();
    renderAvailabilityLabels();
    renderNoteInputs();
    scheduleSecondaryRender();
  }

  function scheduleSecondaryRender() {
    if (secondaryRenderScheduled) return;
    secondaryRenderScheduled = true;
    runWhenIdle(function () {
      secondaryRenderScheduled = false;
      renderHeroProof();
      renderProofSection();
      renderReviewSection();
      if (q('[data-v5-modal="reviews"].is-open')) renderReviewModal();
    }, 450);
  }

  function initDeferredContent() {
    var proofSection = q("#drsknn-v5-proof");
    var reviewSection = q("#drsknn-v5-voices");

    function revealProofLibrary() {
      inlineProofWanted = true;
      mountInlineProofLibrary(false);
    }

    function revealReviewText() {
      ensureGoogleReviews();
      ensurePabauReviews();
      renderReviewSection();
    }

    if (typeof window.IntersectionObserver === "function") {
      deferredObserverTimer = window.setTimeout(function () {
        deferredContentObserver = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (entry.target === proofSection) revealProofLibrary();
            if (entry.target === reviewSection) revealReviewText();
            deferredContentObserver.unobserve(entry.target);
          });
        }, { rootMargin: "0px" });
        if (proofSection) deferredContentObserver.observe(proofSection);
        if (reviewSection) deferredContentObserver.observe(reviewSection);
      }, 600);
    } else {
      runWhenIdle(revealProofLibrary, 1800);
      runWhenIdle(revealReviewText, 2200);
    }

    deferredProofTimer = window.setTimeout(function () {
      runWhenIdle(function () {
        ensureProofAssets(function (loaded) {
          if (loaded) scheduleSecondaryRender();
        });
      }, 2400);
    }, 900);
  }

  root.addEventListener("click", function (event) {
    var target = event.target.closest("button, a");
    if (!target || !root.contains(target)) return;

    if (target.hasAttribute("data-v5-open-consultation")) {
      event.preventDefault();
      openConsultationChooser();
      return;
    }

    var flowOpen = target.getAttribute("data-v5-open-flow");
    if (flowOpen !== null) {
      event.preventDefault();
      openFlow(flowOpen || "area");
      return;
    }

    if (target.hasAttribute("data-v5-flow-prev")) {
      openFlow(state.flowStep - 1);
      return;
    }

    var editStep = target.getAttribute("data-v5-edit-step");
    if (editStep) {
      track("answer_edit", { step: editStep });
      openFlow(editStep);
      return;
    }

    if (target.hasAttribute("data-v5-focus-note")) {
      var noteInput = q("[data-v5-note]", target.closest(".drsknn-v5-route-summary")) || q("[data-v5-note]");
      if (noteInput) {
        noteInput.scrollIntoView({ block: "center", behavior: "smooth" });
        noteInput.focus({ preventScroll: true });
      }
      track("answer_edit", { step: "note" });
      return;
    }

    if (target.hasAttribute("data-v5-flow-next")) {
      var currentStep = FLOW_STEPS[state.flowStep];
      if ((currentStep === "area" && !state.area) || (currentStep === "concern" && !selectedConcernIds().length)) return;
      if (currentStep === "preference") track("flow_complete", { concerns: selectedConcernIds().join(","), preferences: selectedPrefIds().join(",") });
      openFlow(state.flowStep + 1);
      return;
    }

    if (target.hasAttribute("data-v5-show-all-concerns")) {
      showAllConcerns = true;
      renderFlow();
      track("concern_expand", { area: state.area });
      return;
    }

    if (target.hasAttribute("data-v5-clear-prefs")) {
      state.prefs = [];
      state.pref = "";
      saveState();
      renderAll();
      renderFlow();
      track("preferences_clear");
      return;
    }

    if (target.hasAttribute("data-v5-handoff")) {
      openModal("handoff");
      track("handoff_open");
      return;
    }

    var area = target.getAttribute("data-v5-area");
    if (area) {
      resetConcernsForArea(area);
      track("area_select", { area: area });
      renderAll();
      openFlow("concern");
      return;
    }

    var concern = target.getAttribute("data-v5-concern");
    if (concern) {
      var selected = toggleConcernSelection(concern);
      track("concern_select", { concern: concern, concerns: selected.join(",") });
      renderAll();
      if (q('[data-v5-modal="flow"].is-open')) renderFlow();
      else openFlow("concern");
      return;
    }

    var pref = target.getAttribute("data-v5-pref");
    if (pref) {
      var preferences = togglePreference(pref);
      track("preference_select", { preference: pref, preferences: preferences.join(",") });
      renderAll();
      if (q('[data-v5-modal="flow"].is-open')) renderFlow();
      else openFlow("preference");
      return;
    }

    var proofTab = target.getAttribute("data-v5-proof-tab");
    if (proofTab) {
      state.proofCategory = proofTab;
      renderProofSection();
      track("proof_tab", { category: proofTab });
      return;
    }

    if (target.hasAttribute("data-v5-proof-image")) {
      openProofStudio();
      return;
    }

    var reviewTheme = target.getAttribute("data-v5-review-theme");
    if (reviewTheme) {
      if (reviewTheme !== state.reviewTheme) reviewVisibleLimit = REVIEW_PAGE_SIZE;
      state.reviewTheme = reviewTheme;
      ensureReviewsForTheme();
      renderReviewSection();
      if (q('[data-v5-modal="reviews"].is-open')) renderReviewModal();
      track("review_theme", { theme: reviewTheme });
      return;
    }

    if (target.hasAttribute("data-v5-open-matched-proof")) {
      openMatchedProofModal();
      return;
    }

    if (target.hasAttribute("data-v5-open-proof")) {
      openProofStudio();
      return;
    }

    var reviewOpen = target.getAttribute("data-v5-open-reviews");
    if (reviewOpen) {
      openReviews(reviewOpen);
      return;
    }

    var scrollTo = target.getAttribute("data-v5-scroll");
    if (scrollTo) {
      if (scrollTo.indexOf("handoff") !== -1) openModal("handoff");
      else openFlow("route");
      return;
    }

    var role = target.getAttribute("data-v5-book");
    if (role) {
      openBooking(role, target);
      return;
    }

    if (target.hasAttribute("data-v5-proof-prev")) {
      advanceProof(-1);
      return;
    }

    if (target.hasAttribute("data-v5-proof-next")) {
      advanceProof(1);
      return;
    }

    var close = target.closest("[data-v5-close]");
    if (close) {
      event.preventDefault();
      closeModal(target.closest(".drsknn-v5-modal"));
      return;
    }

    var sourceLink = target.getAttribute("data-v5-review-source-link");
    if (sourceLink) {
      event.preventDefault();
      track("review_source_click", { url: sourceLink });
      window.open(sourceLink, "_blank", "noopener");
      return;
    }

    if (target.hasAttribute("data-v5-review-more")) {
      reviewVisibleLimit += REVIEW_PAGE_SIZE;
      renderReviewModal();
      track("review_more", { visible: reviewVisibleLimit, theme: state.reviewTheme });
      return;
    }

    if (target.hasAttribute("data-v5-review-expand")) {
      var card = target.closest("[data-v5-review-card]");
      var preview = card && q("[data-v5-review-preview]", card);
      var full = card && q("[data-v5-review-full]", card);
      if (preview && full) {
        var expanded = !full.hidden;
        full.hidden = expanded;
        preview.hidden = !expanded;
        target.textContent = expanded ? "Read full review" : "Show less";
        track("review_expand", { expanded: !expanded });
      }
    }
  });

  root.addEventListener("input", function (event) {
    if (event.target && event.target.matches("[data-v5-note]")) {
      state.note = event.target.value || "";
      qa("[data-v5-note-summary]").forEach(function (summary) {
        summary.textContent = clean(state.note, 1800) || "None added";
      });
      saveState();
    }
  });

  document.addEventListener("keydown", function (event) {
    var top = modalStack[modalStack.length - 1];
    if (!top) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeModal(top, "escape");
      return;
    }
    if (event.key !== "Tab") return;
    var focusable = qa('a[href],button:not([disabled]),textarea,input,select,iframe,[tabindex]:not([tabindex="-1"])', top).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  root.addEventListener("click", function (event) {
    if (event.target.classList && event.target.classList.contains("drsknn-v5-modal")) {
      closeModal(event.target, "backdrop");
    }
  });

  window.addEventListener("popstate", function () {
    if (suppressNextPopstate) {
      suppressNextPopstate = false;
      return;
    }
    var top = modalStack[modalStack.length - 1];
    if (top) closeModalImmediate(top, "browser_back");
  });

  function updateStickyBookingBar() {
    var sticky = q(".drsknn-v5-sticky");
    if (!sticky) return;
    sticky.classList.toggle("is-visible", window.innerWidth <= 760 && window.scrollY > 160 && !modalStack.length);
  }

  window.addEventListener("scroll", updateStickyBookingBar, { passive: true });
  window.addEventListener("resize", updateStickyBookingBar);

  restoreState();
  applyExternalProofContext();
  renderAll();
  initDeferredContent();
  ensureAvailability();
  updateStickyBookingBar();
  if (!window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    autoTimer = window.setInterval(function () {
      if (!document.hidden && !modalStack.length) advanceProof(1);
    }, 7000);
  }
  window.setTimeout(function () {
    try {
      var requested = new URLSearchParams(window.location.search || "").get("open");
      if (requested === "booking") openConsultationChooser();
      else if (requested === "proof") openProofStudio();
      else if (requested === "route") openConsultationChooser();
    } catch (_) {}
  }, 80);
  window.addEventListener("pagehide", function () {
    if (autoTimer) window.clearInterval(autoTimer);
    if (modalHistoryTimer) window.clearTimeout(modalHistoryTimer);
    if (deferredObserverTimer) window.clearTimeout(deferredObserverTimer);
    if (deferredProofTimer) window.clearTimeout(deferredProofTimer);
    if (deferredContentObserver) deferredContentObserver.disconnect();
    saveState();
    if (bookingState.opened && !bookingState.complete) {
      track("booking_abandon", { role: bookingState.role, reason: "pagehide", seconds_open: Math.round((Date.now() - bookingState.openedAt) / 1000) });
    }
    if (modalStack.some(function (modal) { return modalName(modal) === "flow"; }) && !bookingState.opened && !bookingState.complete) {
      track("route_abandon", { step: FLOW_STEPS[state.flowStep], reason: "pagehide" });
    }
  });
})();
